import { PDFDocument } from "pdf-lib";
import React, { Fragment, useEffect, useState, useRef } from 'react';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  CircularProgress,
  Link,
  Skeleton
} from '@mui/material';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Iconify from '../components/iconify';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api,UploadFile } from '../webservices';
// import { DatatypeModule } from '@faker-js/faker';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const styleSkillset = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: { xs: '60%', sm: '50%' },
  width: '50%',
  bgcolor: 'background.paper',
  border: '3px solid #3C6BA5',
  boxShadow: 24,
  p: 3,
  borderRadius: 3,
};

const styleSkillset12 = {
  position: 'absolute',
  top: "8%",
  left: "9.5%",
  width: '80%',
  minHeight: '85%',
  maxHeight: '85%',
  bgcolor: 'background.paper',
  border: '1px solid #3C6BA5',
  boxShadow: 10,
  p: 3,
  borderRadius: 1,
  overflowY: 'auto',
};

const tablebg = 'rgba(82, 130, 190, 0.08)';
const filter = createFilterOptions();
function Jobs() {
  const navigate = useNavigate();
  // const role = useSelector((state) => state.userData.data.role);
  const role = localStorage.getItem('role');
  const [currentTab, setCurrentTab] = React.useState('Active');
  const [jobList, setJobList] = React.useState([]);
  const [searchResult, setSearchResult] = React.useState();
  const [tempRole, setTempRole] = useState('')
  const [pageNumber, setPageNumber] = useState(1)
  const [pages, setPages] = useState(null)

  // console.log("!!!!!!!!!!!!!searchResult", searchResult)
  // const handlePage = (event, value) => {
  //   console.log(value)
  //   setPageNumber(value);
  //   getJobs(currentTab, value)
  // };

  useEffect(() => {
    getJobs('Active');
  }, []);

  const [tableCount, setTableCount] = useState([])

  const [dataLoading, setDataLoading] = useState(false)

  const openLoadingData = () =>{
    // setDataLoading(true)
  }

  const closeLoadingData = () =>{
    setDataLoading(false)
  }

  const styleLoading = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '95%', sm: '70%' },
    // width: { xs: '85%', sm: '60%' },
    bgcolor: 'background.paper',
    // border: '3px solid #3C6BA5',
    // boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const getJobs = (val, value) => {
    openLoadingData ()
    setJobList([])
    setTableCount([])
    setLoading("Loading...")
    const body = {
      status: val,
      "page": value || 1,
      "limit": "35"
    };
    const token = localStorage.getItem('token');
    Api('company/jobs', 'POST', body, token).then((Response) => {
      if (Response.data.code === 200) {
        if (Response.data.data.length) {
          setLoading("")
          setTableCount(Response.data.count)
          setJobList(Response.data.data);
          // setSearchResult(Response.data.data?.length)
          const totalPage = Math.ceil(Response.data.count / 35)
          setPages(totalPage)
          closeLoadingData ()
        } else {
          setLoading("No Data Found")
          setJobList([])
          closeLoadingData ()
        }
      }
      closeLoadingData()
    });
  };
  const getJobsFun = (val) => {
    getJobs(val);
  };

  const handleTabs = (val) => {
    setCurrentTab(val);
    getJobs(val);
    // getJobs(val);
  }

  // const searchDataFun = (data, count, totalPage) => {
  //   console.log("count", count.length) 
  //   // setTableData(null)
  //   setTableCount(count)
  //   console.log("data", data)
  //   setTableData([''])
  //   // setTableCount([''])
  //   if (valuee !== 'worksheet') {
  //     setValuee('worksheet')
  //   }
  //   // setTableCount(count)
  //   setTableData(data || 0)
  //   setSearchResult(data?.length) 
  //   setPages(totalPage)
  //   setPinned(true)
  // }

  const searchDataFun = (data, count, totalPage) => {
    // alert('hhh')
    setTableCount(count)
    setJobList([])
    if (currentTab !== 'active') {
      setJobList('active')
    }
    setJobList(data)
    setSearchResult(data?.length)
    setPages(totalPage)
  }

  const resetTableData = () => {
    // alert("table")
    getJobs('Active');
  }

  const [loading, setLoading] = useState("")

  useEffect(() => {

  }, [loading]);

  const [tableShow, setTableShow] = useState(true)
  const [searchCall, setSearchCall] = useState(false)
  const hidePage = () => {
    // alert('hello')
    setTableShow(false)
    setSearchCall(true)
  }

  const showtable = () => {
    setTableShow(true)
  }

  const searchFnRef = useRef(() => { });
  const [loadingData1, setLoadingData1] = useState('')
  const handleDataFromChild1 = (fn, loadingData) => {
    setPageNumber(1)
    setLoadingData1(loadingData)
    // console.log("Received fn:", fn);
    if (typeof fn === 'function') {
      searchFnRef.current = fn;
    } else {
      // console.error("Received fn is not a function!");
    }
  };

  // const handlePage = (event, value) => {
  //   console.log(value)
  //   setPageNumber(value);
  //   getJobs(currentTab, value)
  // };

  const handlePage = (event, value) => {
    // console.log("Current searchFn:", searchFnRef.current);
    if (searchCall) {
      setLoading(loadingData1)
      // setPageNumber(1)
      if (typeof searchFnRef.current === 'function') {
        searchFnRef.current(value);
        setPageNumber(value);
      } else {
        // console.error("searchFn is undefined or not a function");
      }
    } else {
      setPageNumber(value);
      getJobs(currentTab, value)
    }
  };

  // const [pageNumber1, setPageNumber1] = useState()

  const handleDataFromChild2 = (number) => {
    // setPageNumber1(number)
    setPageNumber(number)
  }; 







  // console.log("pageNumber", pageNumber)

  return (
    <>
     <Helmet>
        <title> Jobs | Foxearch </title>
      </Helmet>
      <Modal open={dataLoading}>
           <Box
             sx={{
               position: 'absolute',
               top: '50%',
               left: '50%',
               transform: 'translate(-50%, -50%)',
               width: { xs: '80%', sm: '50%', md: '20%' }, 
               bgcolor: 'background.paper',
               boxShadow: 24,
               p: 3, 
               borderRadius: 3,
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center',
               justifyContent: 'center',
             }}
           >
             <Stack spacing={2} alignItems="center">
               <CircularProgress />
               <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
                 Loading... 
               </Typography>
             </Stack>
           </Box>
         </Modal>
         
      <Search searchData={searchDataFun} func={resetTableData} funcc={hidePage} funnc={showtable}
        onData1={handleDataFromChild1}
        onData2={handleDataFromChild2}
        resetSearch={() => setSearchResult('')} /> 

      <ToastContainer />

      <Stack flexDirection={'row'} alignItems={'flex-end'} justifyContent={'space-between'}>
        <Typography variant="h5" color={'text.secondary'}>
          All Jobs
        </Typography>

        {role === 'admin' || role === 'salesHead' || role === "salesManager" || role === 'recruiterHead' || role === 'recruiterManager' || role === 'recruiterTeamLead' ? (
          <Button color="custom" variant="contained" size="small" onClick={() => navigate('/addjob', { state: { row: '' } })}
          // sx={{ml:1}}
          >

            Add New Job
          </Button>
        ) : null}
      </Stack>
      
      {!tableShow && (
        <Typography sx={{ float: "right", mt: 0.5, mb:-3.5 }} fontSize={"0.85rem"} color={'text.secondary'}>
          Total: {searchResult || "0"}
        </Typography>
      )}

      {/* <Stack sx={{ flexDirection: 'row', gap: 2, mb: 0.5, cursor: 'pointer', alignItems: 'center' }}>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === '' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('')

          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            All
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'Active' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('Active')

          }}
        >
          <Iconify icon="iconamoon:star-thin" fontSize={17} color={currentTab === "Active" ? "#2ECC71" : "text.textG"} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Active Job
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'On Hold' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('On Hold')
          }}
        >
          <Iconify icon="mynaui:pause" fontSize={17} color={currentTab === 'On Hold' ? '#F4D03F' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            On Hold
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'Closed' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('Closed')
          }}
        >
          <Iconify icon="material-symbols:block" fontSize={17} color={currentTab === "Closed" ? '#CB4335' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Closed Jobs
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'cancelled' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('cancelled')
          }}
        >
          <Iconify icon="jam:triangle-danger" fontSize={17} color={currentTab === "cancelled" ? '#CB4335' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Cancelled Jobs
          </Typography>
        </Stack>
      </Stack> */}
      
      <Box
  sx={{
    overflowX: { xs: 'auto', sm: 'visible' },
    whiteSpace: { xs: 'nowrap', sm: 'normal' },
    width: '100%',
  }}
>
  <Stack
    sx={{
      flexDirection: 'row',
      gap: 2,
      mb: 0.5,
      cursor: 'pointer',
      alignItems: 'center',
      width: { xs: 'max-content', sm: '100%' },
    }}
  >
    <Stack 
      sx={[
        { flexDirection: 'row' },
        currentTab === '' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
      ]}
      onClick={() => handleTabs('')}
    >
      <Iconify icon="mingcute:list-check-line" fontSize={17} />
      <Typography variant="tabs" sx={{ ml: 1 }}>All</Typography>
    </Stack>

    <Stack
      sx={[
        { flexDirection: 'row' },
        currentTab === 'Active' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
      ]}
      onClick={() => handleTabs('Active')}
    >
      <Iconify icon="iconamoon:star-thin" fontSize={17} color={currentTab === "Active" ? "#2ECC71" : "text.textG"} />
      <Typography variant="tabs" sx={{ ml: 1 }}>Active Job</Typography>
    </Stack>

    <Stack
      sx={[
        { flexDirection: 'row' },
        currentTab === 'On Hold' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
      ]}
      onClick={() => handleTabs('On Hold')}
    >
      <Iconify icon="mynaui:pause" fontSize={17} color={currentTab === 'On Hold' ? '#F4D03F' : 'text.textG'} />
      <Typography variant="tabs" sx={{ ml: 1 }}>On Hold</Typography>
    </Stack>

    <Stack
      sx={[
        { flexDirection: 'row' },
        currentTab === 'Closed' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
      ]}
      onClick={() => handleTabs('Closed')}
    >
      <Iconify icon="material-symbols:block" fontSize={17} color={currentTab === "Closed" ? '#CB4335' : 'text.textG'} />
      <Typography variant="tabs" sx={{ ml: 1 }}>Closed Jobs</Typography>
    </Stack>

    <Stack
      sx={[
        { flexDirection: 'row' },
        currentTab === 'cancelled' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
      ]}
      onClick={() => handleTabs('cancelled')}
    >
      <Iconify icon="jam:triangle-danger" fontSize={17} color={currentTab === "cancelled" ? '#CB4335' : 'text.textG'} />
      <Typography variant="tabs" sx={{ ml: 1 }}>Cancelled Jobs</Typography>
    </Stack>
  </Stack>
</Box>

      <TableContainer component={Paper} >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Date</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '18%' }}>Role</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%' }}>Compensation</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Job Info</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Activity</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Search</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Assignee</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {jobList && jobList.map((item, index) => (
              <JobRow key={item._id} row={item} index={index} cTab={currentTab} role={role} getJobsFun={getJobsFun} currentTab={currentTab}/>
            ))}
            {/* {jobList && jobList.length > 0 ? (
  jobList.map((item, index) => (
    <JobRow
      key={item._id}
      row={item}
      index={index}
      cTab={currentTab}
      role={role}
      getJobsFun={getJobsFun}
    />
  ))
) : (
  <div style={{
    marginLeft: '40rem',
    marginTop: "30px",
    color: 'red',
    fontSize: '12px',
     textAlign: 'center'
  }}>
    No data found
  </div>
)} */}

          </TableBody>
        </Table>
      </TableContainer>
      {/* {jobList.length < 1 && (
        <Stack sx={{ mt: 1 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>no data found</Typography>
        </Stack>
      )} */}

      {/* {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )} */}

{loading === "Loading..." ? (
      <Stack>
  {Array.from({ length: 15 })?.map((_, index) => (
    <Skeleton
      key={index}
      variant="rectangular"
      sx={{
        height: 80, 
        width: '100%',
        backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
      }}
    />
  ))}
</Stack>     

      ):
      <Stack sx={{ mt: 2, p: 2 }}>
           <Typography sx={{ alignSelf: 'center', color: 'red' }}>
             {loading}
            
             </Typography>
         </Stack> 
      } 
      {/* {tableShow && (
        <>
          {jobList?.length > 1 ? (
            <Stack spacing={2} sx={{ alignItems: 'flex-end', width: '100%', mt: 2 }}>
              <Pagination variant="outlined" shape="rounded" color="secondary" count={pages} page={pageNumber} onChange={handlePage} />
            </Stack>
          ) : null}

        </>
      )} */}
      {tableCount > 35 ? (
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2
          }}
        >
          {/* {pageNumber !== 1 && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px',
              mt: 2,
              ml: 0.5, cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
          >
            {"<"}
          </Button>
          {/* )} */}

          <Pagination
            variant="outlined"
            shape="rounded"
            color="secondary"
            hideNextButton
            hidePrevButton
            count={pages}
            page={pageNumber}
            onChange={handlePage}
            sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
          />
          {/* {pageNumber !== pages && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
              mt: -2,
              cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
          >
            {">"}
          </Button>
          {/* )} */}
        </Stack>
      ) : null}
    </>

  );
}

const JobRow = ({ row, index, cTab, getJobsFun, role, currentTab }) => {
  const navigate = useNavigate();
  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const[JobIdsubmitted,setJobIdsubmitted]=useState(null);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openSub, setOpenSub] = useState(false);
  const subCloses = () => setOpenSub(false);
  const subOpen = () => setOpenSub(true);

  const [openInt, setOpenInt] = useState(false);
  const intCloses = () => setOpenInt(false);
  const intOpen = () => setOpenInt(true);

  const [openPla, setOpenPla] = useState(false);
  const plaCloses = () => setOpenPla(false);
  const plaOpen = () => setOpenPla(true);

  const [client, setClient] = useState([]);
  const [openAccessPopup, setOpenAccessPopup] = useState(false);
  const [openstatus, setOpenstatus] = useState(false);
  const statusCloses = () => setOpenstatus(false);
  const [jobTitl, setJobTitl] = useState('')
  const statusOpen = (row) => {
setJobTitl(row)
    setOpenstatus(true);
  }

  const [openP, setOpenP] = useState(false);
  const pCloses = () => setOpenP(false);
  const pOpen = () => setOpenP(true);

  const [openAss, setOpenAss] = useState(false);
  const assCloses = () => setOpenAss(false);
  const [jobId1, setJobId1] = useState('')
  const assOpen = (row) => {
    setJobId1(row?._id)
    setOpenAss(true)
  }

  const [statuss, setStatus] = useState(row.status);
  const [priorityy, setPriority] = useState('');
  const [member, setMember] = useState('individual');  

  const [actionData, setActionData] = useState([]);
  const [assignee, setAssignee] = useState([]);
  const [unAssignee, setUnAssignee] = useState([]);
  const [allUsers, setAllUsers] = useState([])

  const [openJobM, setOpenJobM] = useState(false);
  const closeJobM = () => setOpenJobM(false);
  const openJobMm = () => setOpenJobM(true);
  const [jobUserList, setJobUserList] = useState([])

  const [tempRole, setTempRole] = useState('')
  const [personName, setPersonName] = React.useState([]);
  const [personId, setPersonId] = React.useState([]);
  const [roleUsers, setRoleUsers] = useState([])
  const [underRole, setUnderRole] = useState([])
  const [selectUser, setSelectUser] = useState([])
  const [selectUserId, setSelectUserId] = useState([])
  const [allAssign, setAllAssign] = useState(false)
  const [editAssign, setEditAssign] = useState(false)


  const handleChange = (event) => {
    // console.log('event', event.target.value)
    setPersonName(event.target.value);
    setSelectUser([...selectUser, roleUsers[event.target.value]])
    setSelectUserId([...selectUserId, roleUsers[event.target.value]._id])
    // alert(roleUsers[event.target.value]._id)
    userUnderRole(roleUsers[event.target.value]._id)
    // const {target: { value }, } = event.target.value[0].contactPersonName;
    // setPersonName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // );
  };

  const changeStatus = () => {
    const token = localStorage.getItem('token');
    const body = {
      id: row._id,
      status: statuss,
      noteStatus: `Marked ${statuss}`,
      jobId: row.jobId,
      active: "change Status",
      "jobTitle":jobTitl
    };
    Api('company/newjob', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          statusCloses();
          getJobsFun(cTab);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const changePriority = () => {
    const token = localStorage.getItem('token');
    const body = {
      jobId: row._id,
      priority: priorityy,
    };
    Api('company/set_priority', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          pCloses();
          // getJobsFun(cTab);
          row.priority = priorityy; 
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const [actionStatus1, setActionStatus1] = useState() 

  const jobAction = (val, row) => {
     setJobIdsubmitted(row)
    setActionStatus1(val)
    const token = localStorage.getItem('token');
    const body = {
      jobId: row.jobId,
      status: val,
    };
    Api('company/actionsbyjob', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          setActionData(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const getAllUser = async () => {
    const token = localStorage.getItem('token');
    Api('company/all_users', 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          setAllUsers(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  }

  const asignData = (val) => {
    if (val.target.checked) {
      setAssignee([...assignee, val.target.value])
    } else {
      assignee?.forEach((item, index) => {
        if (item === val.target.value) {
          assignee?.splice(index, 1)
          setAssignee(assignee)
        }
      })
    }
  };

  const unAsignData = (val) => {
    if (val.target.checked) {
      setUnAssignee([...unAssignee, val.target.value])
    } else {
      unAssignee.forEach((item, index) => {
        if (item === val.target.value) {
          unAssignee.splice(index, 1)
          setUnAssignee(unAssignee)
        }
      })
    }
  };

  const AllAsignData = (val) => {
    const tempData = []
    setAllAssign(true)
    allUsers.forEach((item) => {
      tempData.push(item._id)
      // console.log('all-', item._id)
    })
    setAssignee(tempData)

  }

  const [loadingAssignee, setLoadingAssignee] = useState(false)
  const assignJob = async () => {
    setLoadingAssignee(true)
    const token = localStorage.getItem('token');
    const body = {
      "jobId": row._id,
      "assignedTo": member === 'team' ? selectUserId : assignee,
      "assignType": member === 'team' ? 'team' : 'individual'
    };
    Api('company/assignjob', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          assCloses()  
          toast.success(Response.data.message);
          // setActionData(Response.data.data);
          setAssignee([]);
          setLoadingAssignee(false)  
        } else {
          setLoadingAssignee(false)
          // setAssignee([]);
        }
      } else {
        toast.warn(Response.data.error, +'!');
        setLoadingAssignee(false)
        toast.warn(Response.data.resmessage);
        // setAssignee([]);
        setAssignee([]);
      }
    });
  };

  const unAssignJob = async () => {
    const token = localStorage.getItem('token');
    const body = {
      "jobId": row._id,
      "usersToUnassign": unAssignee,
    };
    Api('company/remove_job', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setEditAssign(false)
          closeJobM()
          toast.success(Response.data.message);
          // setActionData(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const jobUsers = async () => {
    openJobMm()
    const token = localStorage.getItem('token');
    Api(`company/users_for_job/${row._id}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setJobUserList(Response.data.data);

          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  }

  const handleRole = (val) => {
    setPersonName([])
    const token = localStorage.getItem('token');
    Api(`company/userbyrole/${val}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setRoleUsers(Response.data.data);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  }

  const userUnderRole = (val) => {
    const token = localStorage.getItem('token');
    Api(`company/underusers/${val}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setUnderRole([...underRole, Response.data.data]);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  }

  const handleRoleUser = (index) => {
    selectUser.splice(index, 1)
    setSelectUser([...selectUser])
    selectUserId.splice(index, 1)
    setSelectUserId([...selectUserId])
    // console.log('selectUserId', selectUserId)
  }

  const [openn, setOpenn] = useState(false);
  const handleOpenn = () => setOpenn(true);
  const handleClosen = () => setOpenn(false);

  const [activityData, setActivityData] = useState([])

  const jobActivity = async () => {
    const token = localStorage.getItem('token');
    const body = {
      "jobId": row.jobId,
    };
    Api('company/jobActivityHistroyList', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        setActivityData(Response.data.result);
        handleOpenn()
        if (Response.data.code === 200) {
          // setActionData(Response.data.data);
        }
      } else {
        handleOpenn()
        // toast.warn(Response.data.error, +'!');
      }
    });
  };

  // console.log("============activityData", activityData.addedByName)

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    // timeZone: 'UTC'
  };

  const [hideBtn, setHideBtn] = useState()
  const [jobTit, setJobTit] = useState()
  const [jobDSkills, setJobDSkills] = useState()
  const [jobSkills, setJobSkills] = useState()
  const [consultModal, setConsultModal] = useState(false)
  const [cityMatch, setCityMatch] = useState()
  const [stateCodeMatch, setSateCodeMatch] = useState()
  const [stateMatch, setStateMatch] = useState()
  const [altMatch, setAltMatch] = useState()

  const openConsultModal = (jobTitle, dSkills, skills, city, stateCode, altJobTitle, state) => {
    setAltMatch(altJobTitle)
    setJobDSkills(dSkills)
    setJobSkills(skills)
    setJobTit(jobTitle)
    setConsultModal(true)
    setCityMatch(city)
    setSateCodeMatch(stateCode)
    setStateMatch(state)
    setValuee("consult")
  }
  // console.log("jobDSlills", jobDSkills)
  // console.log("jobSkills", jobSkills)

  const combinedSkills = [
    // ...(jobDSkills?.map(skill => skill.desiredSkill) || []),
    ...(jobSkills?.map(skill => skill?.mustHaveSkill) || [])
  ];

  // console.log("Combined Skills:", combinedSkills);

  const closeConsultModal = () => setConsultModal(false)
  const [valuee, setValuee] = React.useState('consult');
  const [consultData, setConsultData] = useState([])
  const [loading, setLoading] = useState('')
  const [tableCount, setTableCount] = useState()
  const [pageNumber, setPageNumber] = useState(1)

  const getConsultData = (value) => {
    setHideBtn('')
    setConsultData([])
    setLoading("Loading...")
    setTableCount('')
    getLocalisedData()
    const token = localStorage.getItem('token');
    const body = {
      "jobTitle": jobTit || '',
      "skill": combinedSkills || '',
      "page": value || 1,
      "limit": "50",
      "altJobTitle": altMatch

    }
    Api('bench/jobPopupConsultant', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.result && Response.data.result.length > 0) {
          setConsultData(Response.data?.result);
          setTableCount(Response.data.count)
          setHideBtn(Response.data.result.length)
          const totalPage = Math.ceil(Response.data.count / 35)
          // setPages(totalPage)
          setLoading('');
        } else {
          setLoading('No data found');
        }
      } else {
        setLoading("No data found");
      }
    }).catch(error => {
      setLoading("No data found");

    });
  };

  const [hideTab, setHideTab] = useState(false)
  const [TableDataCon, setTableDataCon] = useState([])

  const getLocalisedData = (value) => {
    setConsultData([])
    setTableDataCon([])
    setLoading("Loading...")
    setTableCount('')
    const token = localStorage.getItem('token');
    const body = {
      "jobTitle": jobTit || '',
      "skill": combinedSkills || '',
      "page": value || 1,
      "limit": "50",
      "altJobTitle": altMatch
    }
    Api('resume/jobPopUpLocalised', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.result) {
          setTableDataCon(Response.data.result)
          // setConsultData(Response.data.result)
          setTableCount(Response.data.count)
          const totalPage = Math.ceil(Response.data.count / 35)
          // setPages(totalPage)
          // setHideTab()
          // setHideTab(Response.data.result?.otherData)
          setLoading('')
        } else {
          setLoading('No data found');
        }
      } else {
        setLoading("")
        // handleOpenn()
        // toast.warn(Response.data.error, +'!');
      }
    });
  };

  const [moveToData, setMoveToData] = useState()
  const selectTab = (tab) => {
    setValuee(tab)
    // setMoveToData(tab)
    const Cities = TableDataCon?.filter(item => item.city === cityMatch && item.state === stateMatch);
    // console.log('Cities===>>>', Cities);
    // console.log('cityMatch===>>>', cityMatch);
    if (tab === 'localised') {
      if (Cities.length > 0) {
        setConsultData(Cities);
        setHideBtn(Cities.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const NoCity = TableDataCon.filter(item => item.city !== cityMatch);
    // console.log('NoCity===>>>', NoCity);
    const States = NoCity.filter(item => item.stateCode === stateCodeMatch);
    // console.log('States===>>>', States);

    if (tab === 'statewise') {
      if (States.length > 0) {
        setConsultData(States);
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const States1 = NoCity.filter(item => item.stateCode !== stateCodeMatch);
    // console.log("States1", States1)
    const Reloca = States1.filter(item => (item.relocation === "yes"));
    // console.log('Reloca===>>>', Reloca);

    if (tab === 'relocation') {
      if (Reloca.length > 0) {
        setConsultData(Reloca);
        setHideBtn(Reloca.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
    const Allover = States1.filter(item => (item.relocation !== "yes"));
    // const Allover = States1.filter(item => item.reallocate !== "yes");
    // console.log('Allover===>>>', Allover);

    if (tab === 'allover') {
      if (Allover.length > 0) {
        setConsultData(Allover);
        setHideBtn(Allover.length)
        setLoading('');
      } else {
        setConsultData([]);
        setLoading('No data found');
      }
    }
  }

  // console.log("hideTab", hideTab)
  useEffect(() => {
    if (consultModal) {
      getConsultData();
      // getLocalisedData()
    }
  }, [consultModal]);

  const [checkedItems, setCheckedItems] = useState({});

  const handleCheck = (itemId) => {
    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  const handleSelectAll = () => {
    const allChecked = consultData.length > 0 && consultData.every(item => checkedItems[item._id]);
    const newCheckedItems = consultData.reduce((acc, item) => {
      acc[item._id] = !allChecked;
      return acc;
    }, {});

    setCheckedItems(newCheckedItems);

  };

  const [loadingMov, setLoadingMov] = useState(false);

  const moveTo = () => {
    setLoadingMov(true)
    const token = localStorage.getItem('token');
    consultData.forEach(item => {
      if (checkedItems[item._id]) {
        if (valuee === "consult") {
          moveToBench(item?.benchAppId, token)
        } else {
          moveToWorksheet(item?.recruitorAppId, token);
        }
      }
    });
    setCheckedItems({})
  };

  const moveToWorksheet = (row, token) => {
    const body = {
      "newCV": "no",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visa,
      taxTerm: row.taxTerm,
      chargeType: row.chargeType,
      expectedCompensation: row.expectedCompensation,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reallocate,
      resumeUrl: row.resumeUrl,
      jobId: row.jobid,
      note: row.notes,
      zipcode: row.zip,
      stateCode: row.scode,
      country: row.country,
      status: row.status,
      userStatus: row.userStatus,
      dataFrom: "foxearchdb"
    };

    Api(`resume/create_resume`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200 && response.data.code === 200) {
          toast.success('Data successfully moved!');
          setLoadingMov(false)
          // selectTab(moveToData)
          //   setValuee(moveToData)
        } else {
          toast.warn("A resume with the same email already exists");
          setLoadingMov(false)

        }
      })
      .catch(error => {
        // console.error('API error:', error);
        // toast.error("An error occurred while moving data.");
      });
  };
  const moveToBench = (row, token) => {
    if (!row.email) {
      toast.error("Email is required");
      return;
    }
    if (!row.fullName) {
      toast.error("Full name is required");
      return;
    }
    if (!row.jobTitle) {
      toast.error("Job title is required");
      return;
    }
    const body = {
      dataFrom: "foxearchdb",
      email: row.email,
      fullName: row.fullName,
      jobTitle: row.jobTitle,
      phone: row.phone,
      currentCompany: row.currCompany,
      skill: row.skill,
      visaType: row.visa,
      visaTransfer: row.visaTrn,
      taxTerm: row.tax,
      chargeType: row.comType,
      expectedCompensation: row.expectedCom,
      cityOrZipcode: row.city,
      linkedinUrl: row.linkedinUrl,
      reallocate: row.reloc,
      zipcode: row.zip,
      stateCode: row.stateCode,
      resumeUrl: row.pdffile,
      state: row.state,
      visaFile: row.pdffileVisa,
      otherFile: row.pdffileOtherDoc,
      i94_File: row.pdffile94,
      DL_File: row.pdffileDL,
      note: row.notes,
      userStatus: row.userStatus,
      country: row.country,
      validity: row.validity,
      DOB: row.dateofbirth,
      summary: row.summary,
      experienceInYear: row.yearExp
    };

    Api(`bench/addNewBenchProspect`, 'POST', body, token)
      .then((response) => {
        // console.log('=====bench==========>>>>>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoadingMov(false);
            toast.success('Data successfully moved!');
            getConsultData();
            setValuee("consult");

          } else {
            toast.warn("A bench worksheet with the same email already exists");
          }
        } else {
          toast.warn("A bench worksheet with the same email already exists");
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.warn("A bench worksheet with the same email already exists");
      })
      .finally(() => {
        setLoadingMov(false);
      });
  };


  useEffect(() => {
    // getSkills();
  }, []);

  const [tempskill, setTempskill] = useState([]);
  const [addedSkill, setAddedSkill] = useState([])
  const getSkills = async () => { 
    const token = localStorage.getItem('token');
    Api(`resume/get_skills/${"other"}`, 'GET', '', token)
      .then((response) => {
        // console.log('=========getSkills======>>>>>>>', response.data);
        if (response.data.code === 200) {
          if (response.data.result.length !== 0) {
            response.data?.result?.map((item) => {
              return tempskill?.push({ title: item?.skillName });
            });
            // setSkill(tempskill);
            setAddedSkill(tempskill)
            // console.log('===value skilll========', JSON.stringify(skill));
          } else {
            // setSkill([{ title: '' }]);
          }
        } else {
          toast.warn(response.data.message, +'!');
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  };

  // const [pages, setPages] = useState(null)

  const handlePage = (valuee) => {
    setPageNumber(pageNumber + 1);
    // console.log(value)
    if (valuee === "consult") {
      // setPageNumber(pageNumber+1)
      getConsultData(pageNumber + 1)
    } else {
      getLocalisedData(pageNumber + 1)
      // setPageNumber(pageNumber+1)
      selectTab(valuee)
    }
    // getJobs(currentTab, value)
  };

  // console.log("PageNumber", pageNumber)
  // console.log("hideBtn", hideBtn)

  const [subStatus, setSubStatus] = useState('');
const [statusNote, setStatusNote] = useState('')

  const [levelM, setLevelM] = useState(false);

  const [statusModal, setStatusModal] = useState(false)
  const [data, setData] = useState()
  const openStatusModal = (item) => {
    setData(item)
    setStatusModal(true)
  }

  const closeStatusModal = () => {
    setStatusModal(false)
  }

  const styleSkillset = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const styleSkillsetDown = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '40%', sm: '55%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    //     paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  const [loadingStatus, setLoadingStatus] = useState(false)

  const Submitted = async () => {
    // console.log("row===>>>>", row)
    setLoadingStatus(true)
    const token = localStorage.getItem('token'); 
    const body = {
      submissionId: data?._id,
      resumeId: data?.resumeId,
      tempSubmitStatus: subStatus,
      note: `Marked ${subStatus} ${statusNote}`,
      // stepWiseStatus: subStatus,
      jobId : data?.type === "position" ? data?.jobId:"",
      clientName:data?.type === "client" ? data?.clientName :''
    };

    Api(`resume/update_sub_status`, 'POST', body, token)
      .then((response) => {
        // console.log('==========update_any_step=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setLoadingStatus(true)
            // setLevelM(false);
            toast.success(response.data.message);
            // console.log(row);
            // fun2();
            setStatusNote('')
            setSubStatus('')
            jobAction("submitted",  data) 
            closeStatusModal()
            // handleOpen();
          } else {
            toast.warn(response.data.message);
            setLoadingStatus(false)
          }
        }
        setLoadingStatus(false)
      })
      .catch((err) => { });
  }; 

  const getDetails = (id) => {
    const body = {
      "resumeId":id
    }
    const token = localStorage.getItem("token")
    Api(`resume/getResumeDetail`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 200) {
            // console.log("ashishg---------------->>>>>", response)
            // setPer(response.data);
            // console.log("response.data?.result", response.data?.result)
            navigate('/resumeDetail', {
              state: {
                row: response.data?.result,
                // row: {
                  
                //   _id: item.resumeId,
                //   resumeId: item.resumeId,
                //   // fullName: row.fullName,
                //   resumeUrl: "",
                // },
                // resumeId: item.resumeId,
               
            //     resumeId:  {
            // _id: item.resumeId,
            //     resumeId: item.resumeId,
            //     },
                fTab: 'submitted',
                mtab: 'Resume',
              },
            });
          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }

  const [Values, setValues] = useState({
   
    fromDate: "",
    tillDate: "",
   
  });

  const [down, setDown] = useState()
  const [openDown, setOpenDown] = useState(false);
const [excelData, setExcelData] = useState([])
 const [excelStatus, setExcelStatus] = useState('')

  const handleOpenDown = () => {
    // setDown(data)
    setOpenDown(true)
}
  const handleCloseDown = () => setOpenDown(false);

  const download = (row) => {
    const body = {
     "actionStatus":actionStatus1,
     "startDate":Values.fromDate,
     "endDate":Values.tillDate,
     "jobId":row?.jobId,
     "clientId":"" 
    }

    const token = localStorage.getItem("token")
    
    Api(`common/jsonToXlsvJobClient?jobId=${row?.jobId}&endDate=${Values.tillDate}&startDate=${Values.fromDate}&actionStatus=${actionStatus1}&clientId=${""}}&token=${token}`, 'GET', '', '')
    .then((response) => {
      // window.open(
      //   `${window.location.origin}/common/jsonToXlsvJobClient?jobId=${row?.jobId}&endDate=${Values.tillDate}&startDate=${Values.fromDate}&actionStatus=${actionStatus1}&clientId=${""}&token=${token}`,
      //   "_blank"
      // );      
      
         if (response.status === 200) { 
          if (response.data.status === 200) {
            // console.log("muza---------------->>>>>", response)
            generateExcel(excelStatus, response.data?.result)
            // console.log("response.data?.result", response.data?.result)
            // setExcelData(response.data.result)
            handleCloseDown()
            setValues({...Values,
              fromDate: "",
    tillDate: ""
  
            })
          //   const link = document.createElement('a');
          // link.href = response.data?.result;
          // const fileDown = actionStatus1 === 'submitted' ? 'submitted.xlsx' : 
          //        actionStatus1 === 'interview' ? 'interview.xlsx' : 
          //        'placement.xlsx';

          // link.download = fileDown;
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // deleteXlsx(response.data?.result)

          } else {
            toast.warn(response.data.message, +'!');
          }
        }
      }) 
      .catch((err) => {
        // console.log('===========', err);
        toast.error(err, +'!');
      });
  }
  const generateExcel = async (excelStatus, result) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    const getExcelColumns = (type) => {
        const columnsMap = {
            placement: [
                { header: "Date", key: "createdAt", width: 25 },
                { header: "Placement Id", key: "PlacementId", width: 15 },
                { header: "Name", key: "Name", width: 30 },
                { header: "Employment Type", key: "EmploymentType", width: 20 },
                { header: "Visa | TT", key: "Visa_TT", width: 25 },
                { header: "Compensation", key: "Compensation", width: 15 },
                { header: "Start Date", key: "StartDate", width: 15 },
                { header: "End Date", key: "EndDate", width: 15 },
                { header: "Status", key: "Status", width: 30 },
                { header: "Presented By", key: "PresentedBy", width: 20 },
            ],
            interview: [
                { header: "Date", key: "createdAt", width: 25 },
                { header: "Name", key: "Name", width: 30 },
                { header: "Email", key: "Email", width: 32 },
                { header: "Mode", key: "Mode", width: 15 },
                { header: "Location", key: "Location", width: 20 },
                { header: "Hiring Manager", key: "HiringManager", width: 20 },
                { header: "Status", key: "Status", width: 30 },
                { header: "Presented By", key: "PresentedBy", width: 20 },
            ],
            submitted: [
                { header: "Date", key: "createdAt", width: 25 },
                { header: "Name", key: "Name", width: 30 },
                { header: "Email", key: "Email", width: 32 },
                { header: "Compensation", key: "Compensation", width: 15 },
                { header: "Visa | TT", key: "Visa_TT", width: 25 },
                { header: "Status", key: "Status", width: 30 },
                { header: "Presented By", key: "PresentedBy", width: 20 },
            ],
        };
        return columnsMap[type] || [];
    };

    worksheet.columns = getExcelColumns(excelStatus);

    const optionsDate = { year: "numeric", month: "short", day: "numeric" };

    const statusPriority = ["L1", "L2", "L3", "L4", "L5"];

    result.forEach((row) => {
        const createdAtDate = new Date(row?.createdAt);
        
        if (excelStatus === "interview") {
            row.createdAt = createdAtDate?.toLocaleString("en-US", optionsDate);
        } else {
            row.createdAt = `${createdAtDate?.toLocaleString("en-US", optionsDate)} ${String(createdAtDate?.getHours())?.padStart(2, "0")}:${String(createdAtDate?.getMinutes())?.padStart(2, "0")}`;
        }

        row.Visa_TT = [row.VisaType, row.TaxTerm].filter(Boolean).join(" | ") || "-";
        row.Status = statusPriority?.includes(row.Status) ? `${row.Status} Interview` : row.Status || "";

        // console.log(row);
        worksheet.addRow(row); 
    });

    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF0000FF" },
    };
    headerRow.alignment = { horizontal: "left" };

    worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
            cell.alignment = { horizontal: "left" };
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, `${excelStatus}.xlsx`);
};

    // const deleteXlsx = (file) => {
    //         const body = {
    //          "filePath":file,
    //         }
    //         const token = localStorage.getItem("token")
    //         Api(`common/deleteXLXvJobClientFile`, 'POST', body, token)
    //           .then((response) => {
    //             if (response.status === 200) {
    //               if (response.data.status === 200) {
    //                 // console.log("muza---------------->>>>>", response)
    //                 // setPer(response.data);
    //                 console.log("response.data?.result", response.data?.result)
                   
    //               } else {
    //                 toast.warn(response.data.message, +'!');
    //               }
    //             }
    //           })
    //           .catch((err) => {
    //             // console.log('===========', err);
    //             toast.error(err, +'!');
    //           });
    //       }

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setValues((prevRec) => ({
      ...prevRec,
      [field]: formattedDate
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };




   const [open1, setOpen1] = useState(false);

  // const data1 = {
  //   years: {
  //     match: "90 %",
  //     summary: "Total 15 years of experience as compared to 10 Years Needs",
  //     color: "#1BAA4B",
  //   },
  //   job: {
  //     match: "80 %",
  //     summary:
  //       "Good Job Tenure minimum 3 years of work in last 5 years in a company",
  //     color: "#1BAA4B",
  //   },
  //   skills: {
  //     match: "75 %",
  //     summary: "Has all the needed skills except Node.js",
  //     color: "#1E73BE",
  //   },
  //   domain: {
  //     match: "35 %",
  //     summary:
  //       "Has worked in finance domain as required in the Job in last project",
  //     color: "#E6A800",
  //   },
  //   location: {
  //     match: "10 %",
  //     summary: "Candidate is 500 miles away form current location",
  //     color: "#E53935",
  //   },
  //   education: {
  //     match: "0 %",
  //     summary: "Has Bachelors degree not masters as required in JD",
  //     color: "#E53935",
  //   },
  //   totalMatch: "90 %",
  // };




 const[rowData,setRowData]=useState({});

  const handleRowClick = (row1) => {
        setRowData({
        _id: row1._id,
        name: row1.fullName,
        resumeText: row1.resumeText,
      })   

  const payload = {
    jobDescription: row.jobDescription,
    candidates: [
      {
        _id: row1._id,
        name: row1.fullName,
        resumeText: row1.resumeText,
      },
    ],
       "jobId": JobIdsubmitted._id,
        "saveScreening": false
  };
       callAPI(payload);
   };

    const handleHeaderClick = () => {
   const allCandidates = actionData.map((row1) => ({
          _id: row1._id,
        name: row1.fullName,
        resumeText: row1.resumeText,
     }));

     const jobDetailsDescription = `
Job Title: ${row.jobTitle},
Experience: ${row?.minExperience} - ${row?.maxExperience},
Must-Have Skill: ${row.skillWithExp[0]?.mustHaveSkill},
Desired Skill: ${row.desiredSkillsWithExp[0]?.desiredSkill},
Degree: ${row.degree[0]?.degree} (${row.degree[0]?.degreeRequired}),
Location: ${row.city || row.location}, ${row.state}, ${row.stateCode}, ${row.country}.
`;

  const payload = {
    // jobDescription: row.jobDescription,
    jobDescription: `${jobDetailsDescription}\n\n${row.jobDescription}`,
    candidates: allCandidates,
     "jobId": JobIdsubmitted._id,
     "saveScreening": false
  };

  callAPI(payload);
        };







const callAPI = async (payload) => {
  console.log('payload===>',payload);
     console.log("*********");
    Api(`ai/match-resumes`, 'POST', payload)
      .then((response) => {
       
        if (response.status === 200) {
          if (response.data.success) {
             jobAction("submitted",  JobIdsubmitted) 
           console.log("match()", response)
          } else {
             console.log("match()else()", response)
          }
        }
      })
      .catch((err) => { });
  }; 

   const[score,setscore]=useState(null);
const [scoreDetails, setScoreDetails] = useState(null);
const [scoreReasons, setScoreReasons] = useState(null);


 const handleScoreClick=(item)=>{

          setRowData({
        _id: item._id,
        name: item.fullName,
        resumeText: item.resumeText,
      }) 
       setScoreDetails(item?.scoreDetails);
       setScoreReasons(item?.scoreReasons);
       setOpen1(true)
       setscore(item.overAllScore)
 }

 console.log("hiiiiii")

 const [confirmOpen, setConfirmOpen] = useState(false);

// const callAPImodel= async () => {
//   const payload = {
//     jobDescription: row.jobDescription,
//     candidates: [rowData ],
//        "jobId": JobIdsubmitted._id,
//          "saveScreening": false
//   };
//     Api(`ai/match-resumes`, 'POST', payload)
//       .then((response) => {
       
//         if (response.status === 200) {
//           if (response.data.success) {
//             console.log("jijdc");
//    console.log("match()", response)           
//        setScoreDetails({...response?.data?.rankedCandidates[0].breakdown});

//               setScoreReasons({...response?.data.rankedCandidates[0].reasons});
//                setOpen1(true)
              
        
//           } else {
//              console.log("match()else()", response)
//           }
//         }
//       })
//       .catch((err) => { });
//   }; 



   const handleConfirmYes = async () => {


  try {
    const jobDetailsDescription = `
Job Title: ${row.jobTitle},
Experience: ${row?.minExperience} - ${row?.maxExperience},
Must-Have Skill: ${row.skillWithExp[0]?.mustHaveSkill},
Desired Skill: ${row.desiredSkillsWithExp[0]?.desiredSkill},
Degree: ${row.degree[0]?.degree} (${row.degree[0]?.degreeRequired}),
Location: ${row.city || row.location}, ${row.state}, ${row.stateCode}, ${row.country}.
`;

    const payload = {
      // jobDescription: row.jobDescription,
    jobDescription: `${jobDetailsDescription}\n\n${row.jobDescription}`,
      candidates: [rowData],
      jobId: JobIdsubmitted._id,
      saveScreening: false
    };

  console.log('payload1', payload);


    const response = await Api('ai/match-resumes', 'POST', payload);

    if (response.status === 200) {

           if(response.data.success)
           {
                        const data = response.data.rankedCandidates[0];
                         setScoreDetails({ ...data.breakdown });
                          setScoreReasons({ ...data.reasons });
                         setOpen1(true);   //  result modal open
                        setConfirmOpen(false); //  confirm modal clos
           }
    
    } else {
      toast.error("Something went wrong");
    }

  } catch (err) {
    console.error(err);
    toast.error("API error");
  } 
};
const handleConfirmNo = () => {
  setConfirmOpen(false);
};
















const [jobId, setjobId] = useState();
const [description, setDescription] = useState();
const [circle, setCircle] = useState(false);
const [parse, setParse] = useState(false);

const parseOpen = () => setParse(true);
const parseClose = () => setParse(false);

const [fileInputFiles, setFileInputFiles] = useState([]);
const [parsedCandidates, setParsedCandidates] = useState([]);

const circleFn = () => setCircle(true);
const circleFn1 = () => setCircle(false);



const compressFile = async (file) => {
  //  sirf PDF compress karenge
  if (file.type !== "application/pdf") {
    return file; // DOC / DOCX same hi bhej dena
  }

  try {
    const buffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(buffer);

    const compressedBytes = await pdf.save({
      useObjectStreams: true,
    });

    console.log("Original:", file.size, "Compressed:", compressedBytes.length);

    return new File([compressedBytes], file.name, {
      type: "application/pdf",
    });
  } catch (err) {
    console.error("Compression failed:", err);
    return file; // agar error aaye to original bhej
  }
};

//  UPDATED: upload + parse combined

 
const uploadMulti = async (file) => {
  const token = localStorage.getItem('token');
   const compressedFile = await compressFile(file);

  const formData = new FormData();
   formData.append('document', compressedFile); 
  
    // formData.append('document', file); 
  formData.append('directoryName', 'resume');

  const uploadRes = await UploadFile(`resume/upload_resume`, formData, token);

  if (!(uploadRes.status === 200 && uploadRes.data.code === 200)) {
    throw new Error("Upload failed");
  }

  const filePath = uploadRes.data.filePath;

  //  parse API
  const body = { resumeUrl: filePath };
  const parseRes = await Api('common/cv/data', 'POST', body, token);

  const data = parseRes.data.result;

  return {
    _id: data._id,
    name: data.fullName || data.name,
    resumeText: data.resumeText
  };
};



const handleAIScreening = async (candidatesData) => {
  const token = localStorage.getItem("token");

  const jobDetailsDescription = `
Job Title: ${row.jobTitle},
Experience: ${row?.minExperience} - ${row?.maxExperience},
Must-Have Skill: ${row.skillWithExp[0]?.mustHaveSkill},
Desired Skill: ${row.desiredSkillsWithExp[0]?.desiredSkill},
Degree: ${row.degree[0]?.degree} (${row.degree[0]?.degreeRequired}),
Location: ${row.city || row.location}, ${row.state}, ${row.stateCode}, ${row.country}.
`;

console.log('row ===>', row)

  const payload = {
    // "jobDescription":row.jobDescription,
    jobDescription: `${jobDetailsDescription}\n\n${row.jobDescription}`,
    "candidates": candidatesData,
    "jobId": row._id,
    "saveScreening": true
  };
  console.log('payload2', payload);
  try {
    const res = await Api('ai/match-resumes', 'POST', payload, token);
       if(res.data.success)
       {
            //  console.log("AI Result:", res.data);
               navigate(`/BulkScreen/${row._id}`, { state: { row } });
       }
       else{
           toast.error(res.data.message)
       }
  
  } catch (err) {
    console.error(err);
  }
};



//  UPDATED: browse upload flow





const handleFileSelect = async (e) => {
  const fileList = Array.from(e.target.files);

  parseClose();
  circleFn();
 // setFileInputFiles(fileList);

  try {
    //  upload + parse (safe way)
      const results = await Promise.allSettled(
          fileList.map(file => uploadMulti(file))
    );

    //  success wale data
    const successResults = results
      .filter(res => res.status === "fulfilled")
      .map(res => res.value);

  
    // if (successResults.length === 0) {
    //   toast.error("This ");
    //   return;
    // }

    // UI update
    setParsedCandidates(successResults);
    console.log("SUCCESS DATA:", successResults);

    //  AI screening call (only success)
    

    //  failed files count
    const failedFiles = results.filter(res => res.status === "rejected");

    if (failedFiles.length >= 0) {
      // toast.error(`${failedFiles.length}`);
      
      if(failedFiles.length >0){
            toast.error(`${failedFiles.length} files could not be uploaded because they exceed 1MB`);
       }
      // toast.error(`${failedFiles.length} files could not be uploaded because they exceed 1MB`);
      // console.error("Failed uploads:", failedFiles);
    }
    if(successResults.length>0)
    {
            await handleAIScreening(successResults);
    }
   

  } catch (err) {
    console.error("Unexpected error:", err);
    toast.error("Something went wrong!");
  } finally {
    circleFn1();
  }
};


//  UPDATED: drag & drop flow



const handleDrop = async (e) => {
  e.preventDefault();
  const fileList = Array.from(e.dataTransfer.files);

//  setFileInputFiles(fileList);
  circleFn();
  try {
    //  safe upload (fail-safe)
    const results = await Promise.allSettled(
      fileList.map(file => uploadMulti(file))
    );

    //  success wale
    const successResults = results
      .filter(res => res.status === "fulfilled")
      .map(res => res.value);

    //  agar sab fail
    // if (successResults.length === 0) {
    //   toast.error("All uploads failed!");
    //   return;
    // }

    setParsedCandidates(successResults);

    //  sirf successful bhejo
  

    //  failed count
    const failedFiles = results.filter(res => res.status === "rejected");
    if (failedFiles.length >=0) {
      // toast.error(`${failedFiles.length} files failed to upload`);
       if(failedFiles.length >0){
            toast.error(`${failedFiles.length} files could not be uploaded because they exceed 1MB`);
       }
      console.error("Failed uploads:", failedFiles);
    }
      if(successResults.length>0)
    {
            await handleAIScreening(successResults);
    }
      // await handleAIScreening(successResults);

  } catch (err) {
    console.error("Unexpected error:", err);
    toast.error("Something went wrong!");
  } finally {
    circleFn1();
  }
};



















//    const[jobId,setjobId]=useState()
//    const[description,setDescription]=useState();
//     const [circle, setCircle] = useState(false)
//    const [parse, setParse] = useState(false);
//    const parseOpen = () => setParse(true);
//    const parseClose = () => setParse(false);
//      const [fileInputFiles, setFileInputFiles] = useState([]);
//      const [parsedCandidates, setParsedCandidates] = useState([]);

    
//  const circleFn = () => {
//         setCircle(true)
//    }

//   const circleFn1 = () => {
//       setCircle(false)
//   }

//     const uploadMulti = (pdf) => {
//         return new Promise((resolve, reject) => {
//           const token = localStorage.getItem('token');
//           const formData = new FormData();
//           formData.append('document', pdf);
//           formData.append('directoryName', 'resume');
    
//           UploadFile(`resume/upload_resume`, formData, token)
//             .then((Response) => {
//               if (Response.status === 200 && Response.data.code === 200) {
//                 ParseRes(Response.data.filePath);
//                 parseClose()
//                 circleFn();
//                 resolve(Response.data.filePath);       
//               } else {
//                 reject(Response.data.message || "Upload failed");
//               }
//             })
//             .catch((err) => reject(err));
//         });
//     };



//     const ParseRes = (parseres) => {
//           const body = {
//             "resumeUrl": parseres
//           }
//           const token = localStorage.getItem("token")
//           Api('common/cv/data', 'POST', body, token).then((Response) => {
//         const data = Response.data.result;
//       const candidateObj = {
//         _id: data._id,
//         name: data.fullName || data.name,
//         resumeText: data.resumeText
//       };
//       setParsedCandidates(prev => [...prev, candidateObj]);
//       circleFn1(); 
      
      
//       // 
//             // console.log("Response", Response)
//             // if (Response.status === 200) {
      
//             //   if (Response.data.code === 403) {
//             //     // setCityStateStyling(true)
//             //     setRow(Response.data.result);
//             //     getResume();
//             //     circleFn1();
//             //     navigate('/resumeDetail', {
//             //       state: {
//             //         addedSkill,
//             //         cityStateStyling,
//             //         row: Response.data.result,
//             //         kTab: "Hide",
//             //         mtab: 'Detail',
//             //         fTab: "submitted",
//             //       },
//             //     });
//             //   } else if (Response.data.code === 200) {
//             //     setRow(Response.data.result);
//             //     getResume();
//             //     circleFn1();
//             //     navigate('/resumeDetail', {
//             //       state: {
//             //         addedSkill,
//             //         row: Response.data.result,
//             //         kTab: "Hide",
//             //         mtab: 'Detail',
//             //         fTab: "submitted",
//             //       },
//             //     });
//             //   } else {
//             //     circleFn1();
//             //     // toast.warn("A resume with the same email already exists");
//             //     setFileInputFiles([])
//             //     toast.warn(Response.data.error);
//             //     getResume();
//             //   }
//             // } else {
//             //   toast.warn('Error!');
//             //   circleFn1();
//             // }
//           })
      
//     }

//     const handleAIScreening = async () => {
//   // const token = localStorage.getItem("token");

//   const payload = {
//     jobDescription: jobDescription, 
//     candidates: parsedCandidates,
//     jobId: jobId ,
//     "saveScreening": true
//   };

//   try {
//     const res = await Api('ai/match-resumes', 'POST', payload, token);
//     console.log("AI Result:", res.data);

//   } catch (err) {
//     console.error(err);
//   }
// };

//   const handleFileSelect = async (e) => {
//           const files = e.target.files;
//           const fileList = Array.from(files);
//           parseClose()
//           circleFn()
//           setFileInputFiles(fileList);
//           try {
//             await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
//           } catch (err) {
//             console.error(err);
//             toast.error("Some uploads failed!");
//           }
      
//   };

//   const handleDrop = async (e) => {
//       e.preventDefault();
//       const files = e.dataTransfer.files;
//       const fileList = Array.from(files);
//       // console.log('files drop', fileList)
  
//       setFileInputFiles(fileList);
//       // fileList.map((item) => uploadMulti(item))
  
//       try {
//         await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
//         // console.log("All resumes uploaded & parsed.");
//       } catch (err) {
//         console.error(err);
//         toast.error("Some uploads failed!");
//       }
  
//     };


    // const [inputExcel, setInputExcel] = useState([]);
    //   const [fileInputFiles, setFileInputFiles] = useState([]);

      const [parsefun, setParsefun] = useState(false);
         const parseOpenfun = () => setParsefun(true);
         const parseClosefun = () => setParsefun(false);



    const [circlefun, setCircleFun] = useState(false)
    const circlefunn = () => {
      setCircleFun(true)
    }
    const circleFn11fun = () => {
      console.log("cloeds ")
      setCircleFun(false)
    }
  

    
      const ParseRes = (parseres) => {
    
        const body = {
          "resumeUrl": parseres,
          "parseFromJob" : true,
           "jobId": row?.jobId
        }
        const token = localStorage.getItem("token")
        console.log("{}{}", body)
        Api('common/cv/data', 'POST', body, token).then((Response) => {

          console.log("[nfjhvbfv", Response)
          // console.log("Response", Response)
          if (Response.status === 200) {
                  //  circleFn11fun();
                   circleFn11fun();
            if (Response.data.code === 403) {
              circleFn11fun();
            } else if (Response.data.code === 200) {
                       console.log("hello")
                         circleFn11fun();
            } else if (Response.data.code === 400) {
              circleFn11fun();
              // toast.warn("A resume with the same email already exists");
              toast.warn(Response.data.message);
            }
          } else {
               circleFn11fun();
            toast.warn('Error!');
         
          }
        })
  
      }
  

      const uploadMultifun = async (pdf) => {
            return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('document', pdf);
      formData.append('directoryName', 'resume');

      UploadFile(`resume/upload_resume`, formData, token)
        .then((Response) => {
          if (Response.status === 200 && Response.data.code === 200) {
            ParseRes(Response.data.filePath);
            // parseClose()
            parseClosefun()
            // circleFn();
            circlefunn()
            resolve(Response.data.filePath);       
          } else {
              reject(Response.data.message || "Upload failed");
          }
        })
        .catch((err) => reject(err));
    });
  };



     const handleFileSelectfun = async (e) => {
    const files = e.target.files;
    const fileList = Array.from(files);
            const file=[]
               file[0]=fileList[0]
               console.log("hello gin ", file)
   

  
             parseClosefun()
             circlefunn();
   
    try {
      // await Promise.all(fileList?.map(async (file) => { await uploadMulti(file) }));
            await Promise.all(file?.map(async (file) => { await uploadMultifun(file) }));
    } catch (err) {
      console.error(err);
      toast.error("Some uploads failed!");
    }

  };

    const handleDropfun = async (e) => {
       e.preventDefault();
       const files = e.dataTransfer.files;
       const fileList = Array.from(files);
       // console.log('files drop', fileList)
   
    
 
   
       try {
         await Promise.all(fileList?.map(async (file) => { await uploadMultifun(file) }));
         // console.log("All resumes uploaded & parsed.");
       } catch (err) {
         console.error(err);
         toast.error("Some uploads failed!");
       }
   
     };















  return (
    <>
      <TableRow
        key={row._id}
        sx={[
          { background: index % 2 === 0 ? 'text.background' : tablebg },
          { '&:last-child td, &:last-child th': { border: 0 } },
          { '&:hover': { boxShadow: 5 } },
        ]}
      >
        <TableCell sx={{}}>
          {/* <Typography sx={{}}>
  
  Up - 
  {row.modified_At ? (
    <>
      {new Date(row.modified_At).toLocaleString('en-US', optionsDate)} 
      {new Date(row.modified_At).toLocaleString('en-US', optionsTime)}
    </>
  ) : (
    " -"
  )}
</Typography> */}
          <Typography sx={{}}>
            Up - {" "}. 
            {row.modified_At ? (         
              <>
                {new Date(row.modified_At)?.toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}{" "}
                {
                  (() => {
                    const date = new Date(row.modified_At);
                    const hours = date.getHours().toString().padStart(2, '0');
                    const minutes = date.getMinutes().toString().padStart(2, '0');
                    return `${hours}:${minutes}`;
                  })()
                }
              </>
            ) : (
              " -"
            )}
          </Typography>



          {/* <Typography sx={{}}>Since {moment().diff(row.createdAT, 'months')} months</Typography> */}
          <Typography sx={{}}>
            {/* Cr - {moment(row.createdAT).format('lll')} */}
            Cr - {`${new Date(row.createdAT)?.toLocaleString('en-US', optionsDate)} 
             ${String(new Date(row?.createdAT)?.getHours())?.padStart(2, '0')}:${String(new Date(row?.createdAT)?.getMinutes())?.padStart(2, '0')}`}
          </Typography>
          <Stack sx={{ flexDirection: 'row', gap: 1 }}>
            {role === 'admin' || role === 'salesHead' || role === "salesManager" || role === 'recruiterHead' || role === 'recruiterManager' || role === 'recruiterTeamLead' ? (
              <Typography
                sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => navigate('/addJob', { state: { row } })}
              >
                Edit
              </Typography>
            ) : (
              <Typography>&nbsp;</Typography>
            )}
            <Stack sx={{ flexDirection: 'row' }}
              onClick={(e) => jobActivity()}

            >
              <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
              <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>

                {row?.clients ? `+ ${row?.clients}` : ''}
              </Typography>
            </Stack>

                            <Iconify
              icon="mdi:file-document-outline"
              color={'text.secondary'}
              sx={{
                m: 0.3,
                height: 16,
                ml: 0.5,
                width: 16,
                cursor: 'pointer',
              }}
               onClick={parseOpenfun}
            />

          </Stack>
        </TableCell>




        <TableCell sx={{}}>
          <Typography
            sx={{
              fontWeight: '600', fontSize: '0.90rem', cursor: 'pointer', maxWidth: 200,
              overflow: 'hidden', textOverflow: 'ellipsis'
            }}
            color={(row.status === "Closed" || row.status === "cancelled" ||
              row.status === "On Hold") ? "red" : "#286ACC"}
            onClick={() => navigate('/jobDetail', { state: { row } })}
          >
            {row?.jobTitle || '-'}

          </Typography>
          {/* <Typography sx={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row.endClientOrImpPartner || '-'} 
          </Typography> */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row.endClientOrImpPartner || '-'}
            </Typography>

            {row.endClientOrImpPartner && (

              <Iconify
                icon="mdi:web"
                color="text.secondary"
                sx={{ ml: 0.5, height: 15, width: 15, cursor: 'pointer' }}
                onClick={() => window.open(row.website, '_blank', 'noopener', 'noreferrer')}
              />
            )}
          </Box>





          <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>
            <Typography sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'#286ACC'}>
              {/* {row.location || '-'} */}
              {row.city || '-'}, {row.stateCode || ''}
            </Typography>
            {row.outOfAreaCandidate === "Yes" && (
              <Iconify icon="mdi:aeroplane" fontSize={20} color={'text.secondary'} />
            )}
          </Stack>

        </TableCell>




        <TableCell sx={{}}>
          {row.compensationType === 'annual' ? (
            <Typography sx={{}} >
              {/* {row?.country ===  "INDIA" ? "₹" :"$"} */}

              {row.country === "INDIA"  ? "₹"  : row.country === "UK" ? "£"  : "$"}

              {row.annualMinCompensation} K{' - '}
              {/* {row?.country ===  "INDIA" ? "₹" :"$"} */}
               {row.country === "INDIA"  ? "₹"  : row.country === "UK" ? "£"  : "$"}

              {row.annualMaxCompensation} K
            </Typography>
          ) : null}
 
          {row.compensationType === 'per hour' ? (
            // <Typography sx={{ textTransform: 'none' }} >
            //   ${row.payRateOn.minPayRate} P/H{' - '}
            //   ${row.payRateOn.maxPayRate} P/H
            // </Typography>

            <Typography sx={{ textTransform: 'none' }}>
  {row.payRateOn?.minPayRate || row.payRateOn?.maxPayRate ? (
  // {row.payRateOn?.minPayRate && row.payRateOn?.maxPayRate ? (
    `${row.payRateOn?.minPayRate} P/H - $${row.payRateOn?.maxPayRate} P/H`
  ) : (
    `$${row.onC2c1099Inc?.minC2c1099Inc} P/H - $${row.onC2c1099Inc?.maxC2c1099Inc} P/H`
  )}
                </Typography>  
 
          ) : null} 

          <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {row.taxTerm.length ? row.taxTerm.map((item, index) => {
              return <Typography key={index} sx={{ textTransform: 'none' }}>{item} {index < row.taxTerm.length - 1 && '|'}</Typography>
            }) : 
            <Typography sx={{ flexDirection: 'row' }}>-</Typography>}
          </Stack>

          {/* <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{row.duration || '-'}</Typography> */}
          <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{row.remote || '-'}</Typography>
        </TableCell>











        <TableCell sx={{}}>
          <Typography sx={{ flexDirection: 'row', color: 'text.secondary', fontWeight: '600' }}>{row.jobId || '-'}</Typography>
          <Typography sx={{ flexDirection: 'row' }}>{row.jobType || '-'}</Typography>
          {row.openings === '1' ? (
            <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{row.openings} opening</Typography>
          ) : (
            <Typography sx={{ flexDirection: 'row', color: 'text.textG' }}>{row.openings} openings</Typography>
          )}
        </TableCell>





        
        <TableCell sx={{}}>
          {/* <Stack sx={{ flexDirection: 'row' }} 
        // onClick={(e) => getClients()}  
        onClick={handleOpenn}
        >
                <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
                <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>
                  
                  {row?.clients ? `+ ${row?.clients}` : ''}
                </Typography>
              </Stack> */}
          <Typography
            sx={{ color: '#286ACC', cursor: 'pointer', fontWeight: '600' }}
            onClick={() => {
              setExcelStatus("submitted")
              handleOpen();
              jobAction('submitted', row);
            }}
          >
            submissions - {row.submittedCount || 0}
          </Typography>
          <Typography
            sx={{ color: '#AE8D18', cursor: 'pointer', fontWeight: '600' }}
            onClick={() => {
              setExcelStatus("interview")
              intOpen();
              jobAction('interview', row);
            }}
          >
            Interviews - {row.interviewCount || 0}
          </Typography>
          <Typography
            sx={{ color: '#399648', cursor: 'pointer', fontWeight: '600' }}
            onClick={() => {
              setExcelStatus("placement")
              plaOpen();
              jobAction('placement', row);
            }}
          >
            Placements - {row.placementCount || 0}
          </Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Typography sx={{ fontWeight: '600', cursor: 'pointer' }} color={'text.secondary'}
            // onClick={() => {
            //   openConsultModal(row.jobTitle, row.desiredSkillsWithExp,
            //     row.skillWithExp, row.city, row.stateCode, row.altJobTitle, row.state)
            // }}>

            onClick={() => navigate('/foxearch', { state: { row } })}
          >
            Foxearch AI 
          </Typography>

               <Typography sx={{ fontWeight: '600', cursor: 'pointer' }} color={'text.secondary'}
               onClick={() => 
                 {
                      parseOpen();
                     // navigate('/BulkScreen')     
                 }
                }
          >
             AI Screen
               </Typography>

          <Typography
  sx={{ fontWeight: 600, cursor: "pointer" }}
  color="text.secondary"
  onClick={() =>
    navigate("/Application", {
      state: { "row": row }
    })
  }
>
  Applications : {row.appliedCount}
</Typography>

        </TableCell>







        <TableCell sx={{}}>
          <Stack sx={{ flexDirection: 'row' }} >
            <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }} onClick={() => jobUsers()}>Assignees</Typography>
            {role === 'admin' || role === 'salesHead' || role === 'recruiterHead' || role === 'recruiterManager' ? (
              <Iconify
                icon="bx:edit"
                // color={'text.secondary'}
                sx={{ height: 15, width: 15, ml: 0.3, cursor: 'pointer', alignSelf: 'center' }}
                onClick={() => { assOpen(row._id); getAllUser() }}
              />
            ) : null}
          </Stack>
          {row.status === "Active" ? (
            <Stack sx={{ flexDirection: 'row', cursor: 'pointer' }}>
              <Typography sx={[{ color: row.priority === 'Top Priority' ? '#399648' : row.priority === 'Mid Priority' ? '#AE8D18' : row.priority === 'Low Priority' ? '#E08787' : null }]}>{row.priority ? row.priority : 'Priority'}</Typography>
              {role === 'admin' || role === 'salesHead' || role === 'recruiterHead' ? (
                <Iconify
                  icon="bx:edit"
                  onClick={() => pOpen()}
                  // color={'text.secondary'}
                  sx={{ height: 15, width: 15, alignSelf: 'center', ml: 0.3 }}
                />
              ) : null}
            </Stack>
          ) : (
            <Typography   >
              Priority
            </Typography>
          )}
          <Typography sx={{ color: 'text.textG', maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}  >
            {row.addedByName ? row.addedByName : '-'}
          </Typography>
        </TableCell> 



        <TableCell sx={{}}>
          <Stack sx={{ flexDirection: 'row', cursor: 'pointer' }}>
            <Typography sx={{}}>{row.status || '-'}</Typography>
            {role === 'admin' || role === 'salesHead' || role === 'recruiterHead' ? (
              <Iconify
                icon="bx:edit"
                onClick={() => statusOpen(row?.jobTitle)}
                // color={'text.secondary'}
                sx={{ height: 15, width: 15, alignSelf: 'center', ml: 0.3 }}
              />
            ) : null}

          </Stack>
          <Typography sx={{ maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row.client || '-'}
          </Typography>
          <Typography sx={{ maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis' }} color={'text.textG'}>
            {row.lead || '-'}
          </Typography>
        </TableCell>
      </TableRow>

      {/* #############################@@@@@@@@@@$$$$$$$$$$$$$$$$%%%%%%%%%%%&&&&&&&&&&************ */}

      {/* <Modal open={levelM} onClose={() => setLevelM(false)} style={{ borderRadius: 10 }}> */}

  <Modal
            open={circlefun}
             onClose={circleFn11fun}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'white',
              padding: '20px',
              boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              {/* <h6 id="simple-modal-title">Parsing resume, Please wait...</h6> */}
              <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
                Parsing resume, Please wait...
              </Typography>
              {/* <p id="simple-modal-description">Modal content goes here.</p> */}
              <Iconify icon="eos-icons:arrow-rotate" width="4rem" color="green" />
              {/* <CircularProgress style={{ display: open ? 'block' : 'none', marginTop: '20px' }} /> */}
            </div>
          </Modal>

                <Modal open={parsefun} onClose={parseClosefun}>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: {
                        xs: '90%',
                        sm: '70%',
                        md: '50%',
                        lg: '30%',
                      },
                      backgroundColor: 'white',
                      border: '4px solid #1E74B3',
                      borderRadius: '13px',
                      p: 2,
                      outline: 'none',
                      maxHeight: '90vh',
                      overflowY: 'auto',
                    }}
                  >
          
                    <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                      <Box
                        sx={{
                          border: '3px dashed #1E74B3',
                          p: 2,
                          borderRadius: '15px',
                          my: 2,
                          textAlign: 'center',
                          color: '#1E74B3',
                        }}
                      >
                        <Typography variant="body1" fontWeight="bold" mb={1}>
                          Browse File
                        </Typography>
                        <input
                          id="file-upload"
                          type="file"
                          accept=".doc,.docx,application/pdf"
                          onChange={handleFileSelectfun}
                          style={{ display: 'none' }}
                          multiple
                        />
                      </Box>
                    </label>
          
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      mb={1}
                      sx={{
                        textAlign: 'center',
                        color: '#1E74B3',
                      }}
                    >
                      OR
                    </Typography>
          
                    <Box
                      sx={{
                        border: '3px solid #1E74B3',
                        p: 2,
                        borderRadius: '15px',
                        my: 2,
                        textAlign: 'center',
                        height: '200px',
                        color: '#1E74B3',
                      }}
                      onDrop={handleDropfun}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      Drag & Drop to Upload File
                    </Box>           
                  </Box>
                </Modal>














      <Modal open={statusModal} onClose={closeStatusModal} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Change Status
          </Typography>
          <Divider />
          <Stack sx={{ justifyContent: 'center', gap: 2, mb: 2, mt: 2, width: '100%' }}>
            <Stack sx={{ alignSelf: 'center', gap: 3, width: '60%' }}>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Select New Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  InputLabelProps={{ shrink: true }}
                  label="Select New Status"
                  placeholder="Select New Status"
                  value={subStatus}
                  onChange={(e) => setSubStatus(e.target.value)}
                >
                  <MenuItem value={'client Submission'}>Client Submission</MenuItem>
                  <MenuItem value={'unqualified'}>Unqualified</MenuItem>
                  <MenuItem value={'shortlisted'}>Shortlisted</MenuItem>
                  <MenuItem value={'job On Hold'}>Job On Hold</MenuItem>
                  <MenuItem value={'out Of Market'}>Out of Market</MenuItem>
                  <MenuItem value={'Duplicate Submission'}>Duplicate Submission</MenuItem>
                </Select>
              </FormControl>

              <FormControl sx={{}}>
                <TextField
                  id="outlined-multiline-static"
                  label="Note... (Max 2000 char)"
                  placeholder="Note..."
                  multiline
                  rows={5}
                  value={statusNote}
                  onChange={(e) => setStatusNote(e.target.value)}
                />
              </FormControl>
              <Button
                color="custom"
                variant="contained"
                sx={{ width: '15%', alignSelf: 'center' }}
                disabled={loadingStatus}
                onClick={(e) => Submitted()}
              >
               
                {loadingStatus ? <CircularProgress size={21} /> : 'Submit'}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      <Modal open={consultModal} onClose={closeConsultModal} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset12}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Box sx={{ ml: "43%", mb: 1 }}>
              <Typography variant="h5" color="textSecondary">
                Foxearch
              </Typography>
            </Box>
            {/* <Stack direction="row" spacing={1}>
              <Button color="custom" variant="contained" size="small" onClick={() => handleSelectAll()}>
                Select All
              </Button>
              <Button color="custom" variant="contained" size="small">
                Email
              </Button>
              <Button color="custom" variant="contained" size="small" disabled={loadingMov} onClick={() => moveTo()}>
                {loadingMov ? <CircularProgress size={24} /> : 'Add to Worksheet'}
              </Button>
            </Stack> */}
          </Stack>

          {/* <Divider sx={{ my: 2 }} />  */}
          <Stack sx={{
            flexDirection: 'row', gap: 2, cursor: 'pointer', alignItems: 'center', mt: -0.1, width: '100%', justifyContent: 'flex-start'
          }}>
            <Stack
              sx={[
                { flexDirection: 'row', alignItems: 'center' },
                valuee === 'consult' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                setPageNumber(1)
                setValuee('consult');
                getConsultData()
              }}
            >
              <Iconify icon="gridicons:multiple-users" fontSize={17} />
              <Typography variant="tabs" sx={{ ml: 1 }}>
                Consultants
              </Typography>
            </Stack>

            <Stack
              sx={[
                { flexDirection: 'row', ml: 1, alignItems: 'center' },
                valuee === 'localised' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                selectTab("localised")
                setPageNumber(1)
              }}
            >
              <Iconify
                icon="icon-park-outline:local"
                fontSize={17}
                color={valuee === 'localised' ? '#B7950B' : 'text.textG'}
              />
              <Typography variant="tabs" sx={{ ml: 1 }}>
                Localised
              </Typography>
            </Stack>

            <Stack
              sx={[
                { flexDirection: 'row', ml: 1, alignItems: 'center' },
                valuee === 'statewise' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                selectTab("statewise")
                setPageNumber(1)
              }}
            >
              <Iconify icon="mdi:sign-real-estate" fontSize={17}
                color={valuee === 'statewise' ? '#F4D03F' : 'text.textG'}
              />
              <Typography variant="tabs" sx={{ ml: 1 }}>
                Statewise
              </Typography>
            </Stack>

            <Stack
              sx={[
                { flexDirection: 'row', ml: 1, alignItems: 'center' },
                valuee === 'relocation' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                selectTab("relocation")
                setPageNumber(1)
              }}
            >
              <Iconify
                icon="mdi:aeroplane"
                fontSize={17}
                color={valuee === 'relocation' ? '#2ECC71' : 'text.textG'}
              />
              <Typography variant="tabs" sx={{ ml: 1 }}>
                Relocation
              </Typography>
            </Stack>

            <Stack
              sx={[
                { flexDirection: 'row', ml: 1, alignItems: 'center' },
                valuee === 'allover' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                selectTab("allover")
                setPageNumber(1)
              }}
            >
              <Iconify icon="subway:world" fontSize={13}
                color={valuee === 'allover' ? '#CB4335' : 'text.textG'}
              />
              <Typography variant="tabs" sx={{ ml: 1 }}>
                All Over
              </Typography>
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ ml: 'auto', mb: 0.6 }}>
              <Button color="custom" variant="contained" size="small" onClick={() => handleSelectAll()}>
                Select All
              </Button>
              <Button color="custom" variant="contained" size="small">
                Email
              </Button>
              <Button color="custom" variant="contained" size="small" disabled={loadingMov}
              // onClick={() => moveTo()}
              >
                {loadingMov ? <CircularProgress size={24} /> : 'Add to Worksheet'}
              </Button>
            </Stack>
          </Stack>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>

                  {valuee !== "consult" ? (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '20%', paddingLeft: 4.9 }}>
                      Date</TableCell>
                  ) : (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%', paddingLeft: 4.9 }}>
                      Date</TableCell>
                  )}

                  {valuee !== "consult" ? (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '16%' }}>
                      Detail
                    </TableCell>
                  ) : (<TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '11%' }}>
                    Detail
                  </TableCell>)}

                  {valuee !== "consult" ? (
                    <TableCell
                      sx={{ p: 1, py: 0.5, color: 'white', width: '22%' }}
                    >
                      Contact Details
                    </TableCell>
                  ) : (<TableCell
                    sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}
                  >
                    Contact Details
                  </TableCell>)}

                  {/* <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '18%' }}>Contact Details</TableCell> */}
                  {/* <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Skills</TableCell> */}
                  {valuee !== "consult" ? (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '19%' }}>
                      Skills
                    </TableCell>
                  ) : (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>
                      Skills
                    </TableCell>
                  )}

                  <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>
                    Visa & Terms
                  </TableCell>

                  {/* {valuee !== "consult" ? (

                    <>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>
                        Status

                      </TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Job Info</TableCell>
                      <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Action</TableCell>
                    </>

                  ) : (
                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Summary</TableCell>
                  )} */}

                  {valuee === "consult" && (

                    <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Summary</TableCell>
                  )}

                </TableRow>
              </TableHead>
              {/* <ConsultRow
        checked1={checked}
        handleChange={handleChange1}
        
      /> */}
              {consultData?.map((item, index) => (
                <ConsultRow
                  key={item._id}
                  index={index}
                  row={item}
                  checked1={checkedItems[item._id]}
                  handleCheck1={() => handleCheck(item._id)}
                  filterTab={valuee}
                  loading={loading}
                  addedSkills={addedSkill}
                  hideTab={hideTab}
                />
              ))}
            </Table>
            {loading !== "" && (
              <Stack sx={{ mt: 2, p: 2 }}>
                <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
              </Stack>
            )}


            {/* {tableCount > 35 ? (
              <Stack
                spacing={2}
                sx={{
                  width: '100%',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  mt: 2
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    minWidth: 16, height: 32, borderRadius: '5px',
                    mt: 2,
                    ml: 0.5, cursor: 'pointer'
                  }}
                  onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
                >
                  {"<"}
                </Button>
                <Pagination
                  variant="outlined"
                  shape="rounded"
                  color="secondary"
                  hideNextButton
                  hidePrevButton
                  count={pages}
                  page={pageNumber}
                  onChange={handlePage}
                  sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
                />
                <Button
                  variant="outlined"
                  sx={{
                    minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
                    mt: -2,
                    cursor: 'pointer'
                  }}
                  onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
                >
                  {">"}
                </Button>

              </Stack>
            ) : null} */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
              {hideBtn > 48 && (

                <Button
                  color="custom" variant="contained" size="small"
                  onClick={() => handlePage(valuee)}
                >
                  Next Batch
                </Button>
              )}
            </Box>

          </TableContainer>
        </Box>
      </Modal>

      {/* ################################@@@@@@@@@@$$$$$$$$$$$$$$$$%%%%%%%%%%%&&&&&&&&&&************ */}

      <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
  <Box sx={[styleSkillset, { width: '90%' }]}>
    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
      Activities
    </Typography>
    <Divider sx={{ mb: 2 }} />

    <Scrollbar sx={{ maxHeight: 400, overflowX: 'auto' }}>
      <Box sx={{ minWidth: 700 }}> 
        <Stack
          sx={{
            backgroundColor: 'text.secondary',
            width: '100%',
            alignItems: 'center',
            p: 0.5,
            borderRadius: 1,
          }}
        >
          <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Typography
              sx={{ width: '22%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}
              color={'text.secondary'}
            >
              Date
            </Typography>
            <Typography
              sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}
              color={'text.secondary'}
            >
              User
            </Typography>
            <Typography
              sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}
              color={'text.secondary'}
            >
              Status
            </Typography>
            <Typography
              sx={{ width: '55%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}
              color={'text.secondary'}
            >
              Note
            </Typography>
          </Stack>
        </Stack>

        {activityData?.map((item, index) => (
          <Stack
            key={index}
            sx={{
              background: index % 2 === 0 ? 'text.background' : tablebg,
              flexDirection: 'row',
              justifyContent: 'space-between',
              p: 1,
            }}
          >
            <Typography sx={{ width: '22%' }}>
              {`${new Date(item.createdAT)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAT)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAT)?.getMinutes())?.padStart(2, '0')}`}
            </Typography>

            <Typography
              sx={{
                width: '15%',
                color: 'text.secondary',
                textTransform: 'capitalize',
                fontWeight: '600',
              }}
            >
              {item.addedByName}
            </Typography>

            <Typography sx={{ width: '25%' }}>
              {item.status === 'Active' && 'Active'}
              {item.status === 'Closed' && 'Closed'}
              {item.status === 'On Hold' && 'On Hold'}
              {item.status === 'cancelled' && 'Cancelled'}
              {!['Active', 'Closed', 'On Hold', 'cancelled'].includes(item.status) && item.status}
            </Typography>

            <Typography sx={{ width: '55%', textTransform: 'capitalize' }}>
              {item.notes}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Scrollbar>
  </Box>
    </Modal>

      {/* <Modal open={open} onClose={handleClose} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '70%', sm: '95%' } }]}>
       
         
  <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: { xs: "center", sm: "space-between" },
              width: "100%",
              position: "relative",
              textAlign: "center",
            }}
          >

            <Typography
              variant="h5"
              color="#3C6BA5"
              sx={{
                position: { sm: "absolute" },
                left: { sm: "50%" },
                transform: { sm: "translateX(-50%)" },
                mb: { xs: 1, sm: 0 },
              }}
            >
              Submissions
            </Typography>

            <Stack
              direction="row"
              spacing={1.9}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-end" },
                width: { xs: "100%", sm: "auto" },
                ml: "auto",
              }}
            >
              <Button color="custom" variant="contained" onClick={()=>handleOpenDown()}>Export</Button>
              
            </Stack>
          </Box>

          <Divider sx={{ mb: 2, mt:1 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ width: '19%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Date
                  </Typography>
                  <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Name
                  </Typography>
                  <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Email
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Compensation
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Visa | TT
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Status
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Presented By
                  </Typography>
                </Stack>
              </Stack>

              {actionData
                ? actionData?.map((item, index) => {
                 
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { '&:last-child td, &:last-child th': { border: 0 } },
                        { '&:hover': { boxShadow: 5 } }, { flexDirection: 'row', justifyContent: 'space-between', width: '100%', p: 1 }
                      ]}
                    >
                      <Typography sx={{ width: '19%' }}>
                      
                        {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAt).getMinutes()).padStart(2, '0')}`}
                      </Typography>

                      <Typography
                        sx={{ width: '25%', textTransform: 'capitalize', fontWeight: '600', color: 'text.secondary', cursor: "pointer" }}

                        onClick={() => {
                          
                          getDetails(item?.resumeId)
                        }
                        }
                      >
                        {item.fullName ? item.fullName : '-'}
                      </Typography>

                      <Typography sx={{ width: '25%', textTransform: 'capitalize', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.prospectEmail ? item.prospectEmail : '-'}
                      </Typography>
                      <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                        ${item.submissionData?.expectedCompensation}{" "}
                        {item.submissionData?.chargeType === 'Annually' ? 'K' : 'P/H'}
                      </Typography>
                      <Typography sx={{ width: '20%', textTransform: 'uppercase' }}>
                      {item.submissionData?.visaType === "Canadian citizen" ? "CC" :
   item.submissionData?.visaType === "Open work permit" ? "OWP" :
   item.submissionData?.visaType === "Permanent Resident" ? "PR" :
   item.submissionData?.visaType || "-"}
{item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}

                        </Typography>
                      <Stack sx={{ flexDirection: "row", width: '20%', mt: -0.5 }}>
                      <Typography
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'capitalize',
    color: item.submissionData?.status === "submitted" ? "#3C6BA5" : '',
    cursor: item.submissionData?.status === "submitted" ? 'pointer' : '',
  }}
  onClick={() => {
    if (item.submissionData?.status === "submitted") {
      
      openStatusModal(item?.submissionData);
    }
  }}
>
  {item.subStatus ? item.subStatus : item.submissionData?.tempSubmitStatus || "Submitted"}

  {!(item?.subStatus === "placement" || item?.subStatus === "rejected" || 
    item?.subStatus === "Duplicate Submission" || item?.subStatus === "unqualified") && (
      <IconButton
        sx={{ mt: -0.2 }}
        onClick={() => navigate('/resumeDetail', {
          state: {
            row: item?.submissionData,
            fTab: 'interview',
            fallBack: "tojobs",
            currentTab
          }
        })}
      >
        <Iconify
          icon="bxs:right-arrow"
          color="#1E74B3"
          width="14px"
        />
      </IconButton>
    )}
</Typography>

                      </Stack>
                      <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                        {item.presentedBy ? item.presentedBy : '-'}
                      </Typography>
                    </Stack>
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={open} onClose={handleClose} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '70%', sm: '95%' } }]}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", sm: "space-between" },
        width: "100%",
        position: "relative",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h5"
        color="#3C6BA5"
        sx={{
          position: { sm: "absolute" },
          left: { sm: "50%" },
          transform: { sm: "translateX(-50%)" },
          mb: { xs: 1, sm: 0 },
        }}
      >
        Submissions
      </Typography>

      <Stack
        direction="row"
        spacing={1.9}
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          width: { xs: "100%", sm: "auto" },
          ml: "auto",
        }}
      >
        <Button color="custom" variant="contained" onClick={handleOpenDown}>
          Export
        </Button>
      </Stack>
    </Box>

    <Divider sx={{ mb: 2, mt: 1 }} />

    <Scrollbar sx={{ maxHeight: 400 }}>
      <Box sx={{ overflowX: 'auto', width: '100%' }}>
        <Stack sx={{ minWidth: '1000px', alignItems: 'center' }}>
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack
              sx={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography sx={{ width: '19%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Date</Typography>
              <Typography sx={{ width: '25%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>End Client Name</Typography>
              <Typography sx={{ width: '25%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Name</Typography>
              <Typography sx={{ width: '25%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Email</Typography>
              <Typography sx={{ width: '15%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Pay</Typography>
              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Visa | TT</Typography>
              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Status</Typography>
              <Typography onClick={handleHeaderClick} sx={{ width: '20%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>AI Screen </Typography>
              <Typography sx={{ width: '20%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Presented By</Typography>
            </Stack>
          </Stack>

          {actionData &&
            actionData.map((item, index) => (
              <Stack
                key={index}
                sx={[
                  {
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    '&:hover': { boxShadow: 5 },
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%',
                    p: 1,
                  },
                ]}
              >
                <Typography sx={{ width: '19%', fontSize: '0.7rem', }}>
                  {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                </Typography>

                <Typography sx={{ width: '25%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                  {item.submissionData?.endClientName|| '-'}
                </Typography>
 
                <Typography
                  sx={{ width: '25%', textTransform: 'capitalize', fontWeight: '600', 
                    color: 'text.secondary', cursor: "pointer", fontSize: '0.7rem', }}
                  onClick={() => getDetails(item?.resumeId)}
                >
                  {item.fullName || '-'}
                </Typography>

                <Typography sx={{ width: '25%',  overflow: 'hidden',
                   textOverflow: 'ellipsis', fontSize: '0.7rem', }}>
                  {item.prospectEmail || '-'}
                </Typography>

                <Typography sx={{ width: '15%', textTransform: 'capitalize', fontSize: '0.7rem', }}>
                  
                   {/* {item?.submissionData?.country === "INDIA"  ? "₹"  : item?.submissionData?.country === "UK" ? "£"  : "$"} */}
                  {localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"}
                  {item.submissionData?.expectedCompensation}{" "}
                  {item.submissionData?.chargeType === 'Annually' ? localStorage.getItem("country") === "INDIA" ? "Lac" :'K' : 'P/H'}
                </Typography>

                <Typography sx={{ width: '20%', textTransform: 'uppercase', fontSize: '0.7rem', }}>
                  {item.submissionData?.visaType === "Canadian citizen" ? "CC" :
                    item.submissionData?.visaType === "Open work permit" ? "OWP" :
                      item.submissionData?.visaType === "Permanent Resident" ? "PR" :
                        item.submissionData?.visaType || "-"}
                  {item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}
                </Typography>

                <Stack sx={{ flexDirection: "row", width: '20%', mt: -0.5 }}>
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      textTransform: 'capitalize',
                       fontSize: '0.7rem',
                      color: item.submissionData?.status === "submitted" ? "#3C6BA5" : '',
                      cursor: item.submissionData?.status === "submitted" ? 'pointer' : '',
                    }}
                    onClick={() => {
                      if (item.submissionData?.status === "submitted") {
                        openStatusModal(item?.submissionData);
                      }
                    }}
                  >
                    {item.subStatus || item.submissionData?.tempSubmitStatus || "Submitted"}

                    {!(["placement", "rejected", "Duplicate Submission", "unqualified"].includes(item?.subStatus)) && (
                      <IconButton
                        sx={{ mt: -0.2 }}
                        onClick={() =>
                          navigate('/resumeDetail', {
                            state: {
                              row: item?.submissionData,
                              fTab: 'interview',
                              fallBack: "tojobs",
                              currentTab
                            }
                          })
                        }
                      >
                        <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
                      </IconButton>
                    )}
                  </Typography>
                </Stack>

                 <Typography
                  

                 onClick={() => {
                      if (item?.overAllScore) {
                          handleScoreClick(item);
                          return;
                        }

                  const aiScreening = localStorage.getItem('aiScreening');

                     if (aiScreening !== 'true') {
                          setOpenAccessPopup(true);
                          return;
                        }

                  handleRowClick(item);
                  }}
                     sx={{     color: '#286ACC', cursor: 'pointer', fontWeight: '600', width: '20%', 
                      fontSize: '0.7rem', }}>
                      {/* {item?.overAllScore ? item.overAllScore: "Screen"}   */}


                      {item?.overAllScore ?  `${item.overAllScore}% Match` :
                            <Button color="custom" variant="contained">
                                   Screen
                                   </Button>
                     }  
                </Typography> 

                <Typography sx={{ width: '20%', textTransform: 'capitalize', fontSize: '0.7rem', }}>
                  {item.presentedBy || '-'}
                </Typography>
              </Stack>
            ))}
        </Stack>
      </Box>
    </Scrollbar>
  </Box>
</Modal>







<Dialog
  open={openAccessPopup}
  onClose={() => setOpenAccessPopup(false)}
  maxWidth="xs"
  fullWidth
  PaperProps={{
    sx: {
      border: '4px solid',
      borderColor: 'text.secondary',
      borderRadius: 2,
    },
  }}
>
  <DialogTitle sx={{ textAlign: 'center', color: 'text.secondary' }}>
    Access Denied!
  </DialogTitle>

  <DialogContent>
    <Typography sx={{ textAlign: 'center', color: 'red' }}>
      Please contact Admin.
    </Typography>
  </DialogContent>

  <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
    <Button
      onClick={() => setOpenAccessPopup(false)}
      variant="contained"
      sx={{ backgroundColor: 'text.secondary' ,
        '&:hover': {
      backgroundColor: 'text.secondary',
    },
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>





      <Modal open={openDown} onClose={handleCloseDown} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillsetDown]}>
          {/* <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Set Priority
          </Typography> */}

          <Divider/>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
          <Grid container sx={{ flexDirection: "row", mt:0.6 }} spacing={2}>
              <Grid item xs={6} sx={{  }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From"
                      slotProps={{ textField: {} }}
                      value={Values.fromDate ? dayjs(Values.fromDate) : null}
                     
                      onChange={(date) => handleDateChange(date, 'fromDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{  }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Till"
                      slotProps={{ textField: { } }}
                      value={Values.tillDate ? dayjs(Values.tillDate) : null}
                    
                      onChange={(date) => handleDateChange(date, 'tillDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '12%', mt: 2.6 }}
              disabled={!(Values.tillDate && Values.fromDate)}
               onClick={()=>download(row)}>
               Download
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>






      <Modal open={openInt} onClose={intCloses}>
      <Box sx={[styleClients, { width: { xs: '70%', sm: '95%' } }]}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'space-between' },
            width: '100%',
            position: 'relative',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            color="#3C6BA5"
            sx={{
              position: { sm: 'absolute' },
              left: { sm: '50%' },
              transform: { sm: 'translateX(-50%)' },
              mb: { xs: 1, sm: 0 },
            }}
          >
            Interviews
          </Typography>

          <Stack
            direction="row"
            spacing={1.9}
            sx={{
              justifyContent: { xs: 'center', sm: 'flex-end' },
              width: { xs: '100%', sm: 'auto' },
              ml: 'auto',
            }}
          >
            <Button color="custom" variant="contained" onClick={handleOpenDown}>
              Export
            </Button>
          </Stack>
        </Box>

        <Divider sx={{ mb: 2, mt: 1 }} />

        <Scrollbar sx={{ maxHeight: 400 }}>
          <Box sx={{ overflowX: 'auto', width: '100%' }}>
            <Stack sx={{ minWidth: '1000px', alignItems: 'center' }}>
             
              <Stack
                sx={{
                  backgroundColor: 'text.secondary',
                  width: '100%',
                  alignItems: 'center',
                  p: 0.5,
                  borderRadius: 1,
                }}
              >
                <Stack
                  sx={{
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                     fontSize: '0.7rem',
                  }}
                >
                  {[
                    { label: 'Date', width: '13%' },
                    { label: 'End Client', width: '13%' },
                    { label: 'Name', width: '15%' },
                    { label: 'Email', width: '17.5%' },
                    { label: 'Mode', width: '8%' },
                    { label: 'Location', width: '10%' },
                    { label: 'Hiring Manager', width: '15%' },
                    { label: 'Status', width: '10%' },
                    { label: 'Presented By', width: '15%' },
                  ].map((col) => (
                    <Typography
                      key={col.label}
                      sx={{
                        width: col.width,
                        color: 'white',
                        fontSize: '0.7rem',
                        fontWeight: '600',
                      }}
                    >
                      {col.label}
                    </Typography>
                  ))}
                </Stack>
              </Stack>

              {actionData &&
                actionData.map((item, index) => (
                  <Stack
                    key={index}
                    sx={[ 
                      {
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        '&:hover': { boxShadow: 5 },
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        p: 1,
                      },
                    ]}
                  >
                    <Typography sx={{ width: '13%', fontSize: '0.7rem' }}>
                      {new Date(item?.createdAt)?.toLocaleString('en-US', optionsDate)}
                    </Typography>

 <Typography sx={{ width: '13%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                                        {item.submissionData?.endClientName|| '-'}
                                        
                                      </Typography>
                    <Typography
                      sx={{
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        width: '15%',
                        color: 'text.secondary',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textTransform: 'capitalize',
                         fontSize: '0.7rem'
                      }}
                      onClick={() => getDetails(item?.resumeId)}
                    >
                      {item.fullName || '-'}
                    </Typography>

                    <Typography
                      sx={{ width: '17%', textTransform: 'none', marginRight: '8px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    >
                      {item.prospectEmail || '-'}
                    </Typography>

                    <Typography sx={{ width: '8%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                      {item.submissionData?.interviewMode === 'phoneic'
                        ? 'Telephonic'
                        : item.submissionData?.interviewMode || '-'}
                    </Typography>

                    <Typography sx={{ width: '10%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                      {item.submissionData?.interviewMode === 'phoneic' ||
                      item.submissionData?.interviewMode === ''
                        ? item.submissionData?.contactNo || '-'
                        : item.submissionData?.interviewMode === 'onsite'
                        ? item.submissionData?.companyAddress || '-'
                        : item.submissionData?.videoPlatform || '-'}
                    </Typography>

                    <Typography sx={{ width: '15%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                      {item.submissionData?.hiringManagerName || '-'}
                    </Typography>

                    <Stack sx={{ flexDirection: 'row', width: '10%', mt: -0.5, fontSize: '0.7rem' }}>
                      <Typography sx={{ textTransform: 'capitalize' }}>
                        {item.subStatus ||
                          `${item.submissionData?.stepWiseStatus || ''} Interview`}

                        {!item.subStatus && (
                          <IconButton
                            sx={{ mt: -0.2 }}
                            onClick={() =>
                              navigate('/resumeDetail', {
                                state: {
                                  row: item?.submissionData,
                                  fTab: 'placement',
                                  fallBack: 'tojobs',
                                  currentTab,
                                },
                              })
                            }
                          >
                            <Iconify
                              icon="bxs:right-arrow"
                              color="#1E74B3"
                              width="14px"
                            />
                          </IconButton>
                        )}
                      </Typography>
                    </Stack>

                    <Typography sx={{ width: '15%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                      {item.presentedBy || '-'}
                    </Typography>
                  </Stack>
                ))}
            </Stack>
          </Box>
        </Scrollbar>
      </Box>
    </Modal>

    <Modal open={openPla} onClose={plaCloses} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '90%', sm: '100%' } }]}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'space-between' },
        width: '100%',
        position: 'relative',
        textAlign: 'center'
      }}
    >
      <Typography
        variant="h5"
        color="#3C6BA5"
        sx={{
          position: { sm: 'absolute' },
          left: { sm: '50%' },
          transform: { sm: 'translateX(-50%)' },
          mb: { xs: 1, sm: 0 }
        }}
      >
        Placements
      </Typography>

      <Stack
        direction="row"
        spacing={1.9}
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', sm: 'flex-end' },
          width: { xs: '100%', sm: 'auto' },
          ml: 'auto'
        }}
      >
        <Button color="custom" variant="contained" onClick={handleOpenDown}>
          Export
        </Button>
      </Stack>
    </Box>

    <Divider sx={{ mb: 2, mt: 1 }} />

    <Scrollbar sx={{ maxHeight: 400 }}>
      <Box sx={{ overflowX: 'auto', width: '100%' }}>
        {/* <Stack sx={{ minWidth: '1200px' }}>
         
         <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack
              sx={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography sx={{ width: '117px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Date</Typography>
    <Typography sx={{ width: '125px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>End Client Name</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Placement Id</Typography>
    <Typography sx={{ width: '125px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Name</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Emp Type</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Visa | TT</Typography>
    <Typography sx={{ width: '100px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Pay</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Start Date</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>End Date</Typography>
    <Typography sx={{ width: '100px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Status</Typography>
    <Typography sx={{ width: '119px', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Presented By</Typography>
            </Stack> 
          </Stack> 

          {actionData?.map((item, index) => ( 
            <Stack
              key={item?._id || index}
              sx={{
                background: index % 2 === 0 ? 'text.background' : tablebg,
                '&:last-child td, &:last-child th': { border: 0 },
                '&:hover': { boxShadow: 5 },
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                p: 1
              }}
            >
              <Typography sx={{ width: '117px', flexShrink: 0, fontSize: '0.7rem' }}>
                {`${new Date(item?.createdAt)?.toLocaleString('en-US', optionsDate)} ${String(
                  new Date(item?.createdAt)?.getHours()
                )?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
              </Typography>

              <Typography sx={{  width: '125px', flexShrink: 0, textTransform: 'capitalize',fontSize: '0.7rem' }}>
                                                      {item.submissionData?.endClientName|| '-'}
                                                   
                                                    </Typography>
 
              <Typography sx={{ width: '119px', flexShrink: 0,fontSize: '0.7rem' }}>{item?.placementId || '-'}</Typography>
              <Typography
                sx={{
                  width: '125px',
                  textTransform: 'capitalize',  
                  overflow: 'hidden',
                  whiteSpace: 'nowrap', 
                  textOverflow: 'ellipsis',  
                  color: 'text.secondary',
                  fontSize: '0.7rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
                onClick={() => getDetails(item?.resumeId)}
              >
                {item.fullName || '-'}
              </Typography>
              <Typography sx={{ width: '119px', textTransform: 'capitalize', flexShrink: 0,fontSize: '0.7rem' }}>
                {item.submissionData?.offeredJob || '-'}
              </Typography>
              <Typography sx={{ width: '119px', textTransform: 'capitalize', flexShrink: 0,fontSize: '0.7rem' }}>
                {item.submissionData?.visaType === 'Canadian citizen'
                  ? 'CC'
                  : item.submissionData?.visaType === 'Open work permit'
                  ? 'OWP'
                  : item.submissionData?.visaType === 'Permanent Resident'
                  ? 'PR'
                  : item.submissionData?.visaType || '-'}
                {item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}
              </Typography>
              <Typography sx={{ width: '100px', textTransform: 'capitalize', flexShrink: 0,fontSize: '0.7rem' }}>
                $ {item.submissionData?.expectedCompensation}{' '}
                {item.submissionData?.chargeType === 'Annually' ? 'K' : 'P/H'}
              </Typography>
              <Typography sx={{ width: '119px', flexShrink: 0,fontSize: '0.7rem' }}>
                {item.submissionData?.tentativeStartDate
                  ? new Date(item.submissionData?.tentativeStartDate)?.toLocaleString('en-US', optionsDate)
                  : '-'}
              </Typography>
              <Typography sx={{ width: '119px', flexShrink: 0 ,fontSize: '0.7rem'}}>
                {item.submissionData?.terminatedAt
                  ? new Date(item.submissionData?.terminatedAt)?.toLocaleString('en-US', optionsDate)
                  : '-'}
              </Typography>
              <Stack sx={{ flexDirection: 'row', width: '100px', mt: -0.5, flexShrink: 0 }}>
                <Typography sx={{ textTransform: 'capitalize' ,fontSize: '0.7rem'}}>
                  {item.subStatus || item.submissionData?.status || '-'}
                  {(item.submissionData?.status !== 'rejected' &&
                    item.subStatus !== 'started' &&
                    item.subStatus !== '') ||
                  !item.subStatus ? null : (
                    <IconButton
                      sx={{ mt: -0.2 }} 
                      onClick={() =>
                        navigate('/resumeDetail', {
                          state: {
                            row: item?.submissionData,
                            fTab: 'start',
                            q: item.subStatus === 'started' ? 'quit' : '',
                            fallBack: 'tojobs',
                            currentTab
                          }
                        })
                      }
                    >
                      <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
                    </IconButton>
                  )}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  width: '119px',
                  textTransform: 'capitalize',
                  fontWeight: '600',
                  color: 'text.secondary',
                  flexShrink: 0,
                  fontSize: '0.7rem'
                }}
              >
                {item.presentedBy || '-'}
              </Typography>
            </Stack>
          ))}
        </Stack> */}

        <Stack sx={{ minWidth: '1200px', width: '100%' }}>
  <Stack
    sx={{
      backgroundColor: 'text.secondary',
      width: '100%',
      alignItems: 'center',
      p: 0.5,
      borderRadius: 1,
    }}
  > 
    <Stack 
      sx={{
        width: '100%',  
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <Typography sx={{ width: '8.86%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Date</Typography>
      <Typography sx={{ width: '11%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>End Client Name</Typography>
      <Typography sx={{ width: '9%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Placement Id</Typography>
      <Typography sx={{ width: '11%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Name</Typography>
      <Typography sx={{ width: '9.01%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Emp Type</Typography>
      <Typography sx={{ width: '9.01%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Visa | TT</Typography>
      <Typography sx={{ width: '6%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Pay</Typography>
      <Typography sx={{ width: '9.01%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Start Date</Typography>
      <Typography sx={{ width: '9.01%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>End Date</Typography>
      <Typography sx={{ width: '6%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Status</Typography>
      <Typography sx={{ width: '9.01%', color: 'white', fontSize: '0.7rem', fontWeight: '600' }}>Presented By</Typography>
    </Stack>
  </Stack>
 
  {actionData?.map((item, index) => (
    <Stack
      key={item?._id || index}  
      sx={{
        background: index % 2 === 0 ? 'text.background' : tablebg,
        '&:hover': { boxShadow: 5 },
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
        p: 1,
      }}
    >
      <Typography sx={{ width: '8.86%', flexShrink: 0, fontSize: '0.7rem' }}>
        {`${new Date(item?.createdAt)?.toLocaleString('en-US', optionsDate)} ${String(
          new Date(item?.createdAt)?.getHours()
        ).padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes()).padStart(2, '0')}`}
      </Typography>

      <Typography sx={{ width: '11%', flexShrink: 0, textTransform: 'capitalize', fontSize: '0.7rem' }}>
        {item.submissionData?.endClientName || '-'}
      </Typography>

      <Typography sx={{ width: '9.01%', flexShrink: 0, fontSize: '0.7rem' }}>{item?.placementId || '-'}</Typography>

      <Typography
        sx={{
          width: '11%',
          textTransform: 'capitalize',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          color: 'text.secondary',
          fontSize: '0.7rem',
          fontWeight: '600',
          cursor: 'pointer',
          flexShrink: 0,
        }}
        onClick={() => getDetails(item?.resumeId)}
      >
        {item.fullName || '-'}
      </Typography>

      <Typography sx={{ width: '9.01%', textTransform: 'capitalize', flexShrink: 0, fontSize: '0.7rem' }}>
        {item.submissionData?.offeredJob || '-'}
      </Typography>

      <Typography sx={{ width: '9.01%', textTransform: 'capitalize', flexShrink: 0, fontSize: '0.7rem' }}>
        {item.submissionData?.visaType === 'Canadian citizen'
          ? 'CC'
          : item.submissionData?.visaType === 'Open work permit'
          ? 'OWP'
          : item.submissionData?.visaType === 'Permanent Resident'
          ? 'PR'
          : item.submissionData?.visaType || '-'}
        {item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}
      </Typography>

      <Typography sx={{ width: '6%', textTransform: 'capitalize', flexShrink: 0, fontSize: '0.7rem' }}>
        {/* {item?.submissionData?.country ===  "INDIA" ? "₹" :"$"} */}
         {item?.submissionData?.country === "INDIA"  ? "₹"  : item?.submissionData?.country === "UK" ? "£"  : "$"}

        {item.submissionData?.expectedCompensation}{' '}
        {item.submissionData?.chargeType === 'Annually' ? 'K' : 'P/H'}
      </Typography>

      <Typography sx={{ width: '9.01%', flexShrink: 0, fontSize: '0.7rem' }}>
        {item.submissionData?.tentativeStartDate
          ? new Date(item.submissionData?.tentativeStartDate)?.toLocaleString('en-US', optionsDate)
          : '-'}
      </Typography>

      <Typography sx={{ width: '9.01%', flexShrink: 0, fontSize: '0.7rem' }}>
        {item.submissionData?.terminatedAt
          ? new Date(item.submissionData?.terminatedAt)?.toLocaleString('en-US', optionsDate)
          : '-'}
      </Typography>

      <Stack sx={{ flexDirection: 'row', width: '6%', mt: -0.5, flexShrink: 0 }}>
        <Typography sx={{ textTransform: 'capitalize', fontSize: '0.7rem' }}>
          {item.subStatus || item.submissionData?.status || '-'}
          {(item.submissionData?.status !== 'rejected' &&
            item.subStatus !== 'started' &&
            item.subStatus !== '') ||
          !item.subStatus ? null : (
            <IconButton
              sx={{ mt: -0.2 }}
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    row: item?.submissionData,
                    fTab: 'start',
                    q: item.subStatus === 'started' ? 'quit' : '',
                    fallBack: 'tojobs',
                    currentTab,
                  },
                })
              }
            >
              <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
            </IconButton>
          )}
        </Typography>
      </Stack>

      <Typography
        sx={{
          width: '9.01%',
          textTransform: 'capitalize',
          fontWeight: '600',
          color: 'text.secondary',
          flexShrink: 0,
          fontSize: '0.7rem',
        }}
      >
        {item.presentedBy || '-'}
      </Typography>
    </Stack>
  ))}
</Stack>

      </Box>
    </Scrollbar>
  </Box>
     </Modal>

      <Modal open={openstatus} onClose={statusCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Change Status
          </Typography>

          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid
              container
              sx={{ mt: 2, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
              gap={2}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id="demo-simple-select-label">Select New Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select New Status"
                  value={statuss}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={'Active'}>Active</MenuItem>;<MenuItem value={'Closed'}>Closed</MenuItem>;
                  <MenuItem value={'On Hold'}>On Hold</MenuItem>;<MenuItem value={'cancelled'}>Cancelled</MenuItem>;
                </Select>
              </FormControl>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }} onClick={() => changeStatus()}>
                Submit
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
      <Modal open={openP} onClose={pCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Set Priority
          </Typography>

          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid
              container
              sx={{ mt: 2, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
              gap={2}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id="demo-simple-select-label">Select Priority</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select Priority"
                  InputLabelProps={{ shrink: true }}
                  value={priorityy}
                  onChange={(e) => setPriority(e.target.value)}
                >
                  <MenuItem value={'Top Priority'}>Top Priority</MenuItem>
                  <MenuItem value={'Mid Priority'}>Mid Priority</MenuItem>;
                  <MenuItem value={'Low Priority'}>Low Priority</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }} onClick={() => changePriority()}>
                Submit
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
      <Modal open={openAss} onClose={assCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { p: 1, width: '60%' }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Assign Professionals
          </Typography>

          <Divider />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin', p: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Resources</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Select Resources"
                placeholder="Select Resources"
                value={member}
                onChange={(e) => {
                  setMember(e.target.value);
                  if (e.target.value === 'all') {
                    AllAsignData()
                  } else {
                    setAssignee([])
                  }
                }}
              >
                <MenuItem value={"all"}>All</MenuItem>
                <MenuItem value={"individual"}>Individual</MenuItem>
                <MenuItem value={"team"}>Team</MenuItem>
              </Select>
            </FormControl>
            {member === 'team' && (
              <>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select Resources"
                    placeholder="Select Resources"
                    value={tempRole}
                    onChange={(e) => { setTempRole(e.target.value); handleRole(e.target.value) }}
                  >
                    <MenuItem value={"recruiterHead"}>RH</MenuItem>
                    <MenuItem value={"recruiterManager"}>RM</MenuItem>
                    <MenuItem value={"recruiterTeamLead"}>RL</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="demo-multiple-checkbox-label">Users</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    // multiple        
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Tag" />}
                  // renderValue={(selected) => selected.join(', ')}
                  // MenuProps={MenuProps}
                  >
                    {roleUsers.map((name, index) => (
                      <MenuItem key={name._id} value={index}>
                        {/* <Checkbox checked={personName.indexOf(name.contactPersonName) > -1} value={name._id}  /> */}
                        <ListItemText primary={name.contactPersonName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {selectUser.length > 0 && (
                  <Grid container gridTemplateColumns={{ sm: 'repeat(8, 1fr)', xs: 'repeat(8, 1fr)' }} sx={{ mt: 1, gap: 1 }}>
                    {selectUser.map((item, index) => {
                      return <Stack sx={{ flexDirection: 'row', border: 1, borderRadius: 1, p: 0.5, borderColor: 'text.secondary' }}>
                        <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>{item.contactPersonName}</Typography>
                        <Icon icon="jam:close" color={'red'} fontSize={16} sx={{ cursor: 'pointer', mt: -1 }}
                          onClick={() => handleRoleUser(index)}
                        />
                      </Stack>
                    })}
                  </Grid>
                )}

                <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                  {underRole.map((item, index) => {
                    return <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                      {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                      <FormControlLabel
                        control={<Checkbox defaultChecked disabled />}
                        value={item._id}
                      // onChange={(e) => asignData(e)}
                      />
                      <Typography sx={{ ml: -3 }}>{item.contactPersonName} {" "}{item.USERID}</Typography>
                      {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                    </Stack>
                  })}
                </Grid>
              </>
            )}
            {member === 'individual' && (
              <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                {allUsers?.map((item, index) => {
                  return <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                    <FormControlLabel
                      control={<Checkbox />}
                      value={item._id}
                      onChange={(e) => asignData(e)}
                    />
                    <Typography sx={{ ml: -3 }}>{item.contactPersonName} {" "}{item.USERID}</Typography>
                    {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                  </Stack>
                })}
              </Grid>
            )}

            {member === 'all' && (
              <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                {allUsers.map((item, index) => {
                  return <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                    <FormControlLabel
                      control={<Checkbox checked={allAssign} />}
                      value={item._id}
                    // onChange={(e) => asignData(e)}
                    />
                    <Typography sx={{ ml: -3 }}>{item.contactPersonName} {" "}{item.USERID}</Typography>
                    {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                  </Stack>
                })}
              </Grid>
            )}
            {/* <Grid container sx={{ mt: 2 ,flexDirection:'column',justifyContent:'center',alignItems:'center'}}  gap={2}>
            
            
          </Grid> */}
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }}
                onClick={() => assignJob()}>
                {/* Submit */}
                 {loadingAssignee ? <CircularProgress size={24} /> : 'Submit'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openJobM} onClose={closeJobM} style={{ borderRadius: 10 }}>
  <Box sx={[styleSkillset, { p: 1, width: '90%' }]}>
    <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
      <Icon icon="bx:edit" fontSize={16} sx={{ cursor: 'pointer', mt: -1 }} onClick={() => setEditAssign(true)} />
    </Stack>
    <Typography variant="h5" color={'#3C6BA5'} sx={{ mt: -3 }} textAlign={'center'}>
      {!editAssign ? "Assigned" : "Unassigned"} Professionals
    </Typography>
    <Divider />
    <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin', p: 2 }}>
     
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: '600px' }}> 
          {!editAssign ? (
            <>
              <Grid display={'grid'} gap={1} gridTemplateColumns={{ sm: 'repeat(3, 1fr)', xs: 'repeat(3, 1fr)' }}>
                <Stack sx={{ flexDirection: 'row', backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    User ID
                  </Typography>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Name
                  </Typography>
                </Stack>
                <Stack sx={{ flexDirection: 'row', backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    User ID
                  </Typography>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Name
                  </Typography>
                </Stack>
                <Stack sx={{ flexDirection: 'row', backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    User ID
                  </Typography>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Name
                  </Typography>
                </Stack>
              </Grid>
    
              <Grid gap={1} display={'grid'} gridTemplateColumns={{ sm: 'repeat(3, 1fr)', xs: 'repeat(3, 1fr)' }}>
                {jobUserList?.map((item, index) => {
                  return (
                    <Stack
                      key={index}
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                      ]}
                    >
                      <Typography sx={{ width: '50%' }}>
                        {item?.USERID}
                      </Typography>
                      <Typography sx={{ width: '50%', textTransform: 'capitalize', fontWeight: '600', color: 'text.secondary' }}>
                        {item?.contactPersonName}
                      </Typography>
                    </Stack>
                  );
                })}
              </Grid>
            </>
          ) : (
            <>
              <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                {jobUserList?.map((item, index) => {
                  return (
                    <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                      <FormControlLabel control={<Checkbox />} value={item._id} onChange={(e) => unAsignData(e)} />
                      <Typography sx={{ ml: -3 }}>{item?.contactPersonName} {" "}{item?.USERID}</Typography>
                    </Stack>
                  );
                })}
              </Grid>
              <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }} onClick={() => unAssignJob()}>
                  Unassign
                </Button>
              </Stack>
            </>
          )}
        </div>
      </div>
    </Scrollbar>
  </Box>
  </Modal> 




         <Modal open={open1} onClose={() => setOpen1(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
     
          width: { xs: "85%", sm: "85%", md: "670px" },

          bgcolor: "#fff",
          border: "3px solid #2f5f9e",
          borderRadius: "8px",
          p: 2,
          outline: "none",
        }}
      >
    
        <Typography
          align="center"
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            mb: 2,
            color: "#2f5f9e",
          }}
        >
          Screening Analysis
        </Typography>

       

        <Box sx={{ overflowX: "auto" }}>


       
        <Box
          sx={{
            backgroundColor: "#3b6ea5",
            display: "flex",
            padding: "10px",
            borderRadius: "6px",
            color: "#fff",
            fontWeight: "bold",
          }}
        >
          <Box sx={{ width: "25%" }}>Parameters</Box>
          <Box sx={{ width: "17%" }}> % Match</Box>
          <Box sx={{ width: "58%" }}>Summary</Box>
        </Box>

{/*      

        <Row label="Years of Exp :" item={scoreDetails?.experienceScore} summary={scoreReasons?.experience}
 />
        <Row label="Job Tenure" item={scoreDetails?.tenureScore} summary={scoreReasons?.tenure} />
        <Row label="Skills :" item={scoreDetails?.skillsScore} summary={scoreReasons?.skills} />
        <Row label="Domain :" item={scoreDetails?.domainScore} summary={scoreReasons?.domain} />
        <Row label="Location :" item={scoreDetails?.locationScore} summary={scoreReasons?.location} />
        <Row label="Education :" item={scoreDetails?.educationScore} summary={scoreReasons?.education} />  */}


           
              <Row label="Years of Exp :" item={scoreDetails?.experienceScore} summary={scoreReasons?.experience}
       />
              <Row label="Job Title" item={(scoreDetails?.jobTitleScore)} summary={scoreReasons?.jobTitle} />
              <Row label="Job Tenure" item={scoreDetails?.tenureScore} summary={scoreReasons?.tenure} />

              <Row label="Skills :" item={scoreDetails?.skillsScore} summary={scoreReasons?.skills} />
              {/* <Row label="Domain :" item={scoreDetails?.domainScore} summary={scoreReasons?.domain} /> */}
              <Row label="Location :" item={scoreDetails?.locationScore} summary={scoreReasons?.location} />
              <Row label="Education :" item={scoreDetails?.educationScore} summary={scoreReasons?.education} /> 
               <Row label="Domain:" item={scoreDetails?.domainScore} summary={scoreReasons?.domain} />
         </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            //  onClick={callAPImodel}
               onClick={() => setConfirmOpen(true)}
            sx={{
              backgroundColor: "#3b6ea5",
              borderRadius: "8px",
              px: 4,
              fontWeight: "bold",
              textTransform: "none",
              "&:hover": { backgroundColor: "#2f5f9e" },
            }}
          >
       {/* {score} % Match */}  Screen
          </Button>
        </Box>
      </Box>
         </Modal> 

      <Modal open={parse} onClose={parseClose}>
             <Box
               sx={{
                 position: 'absolute',
                 top: '50%',
                 left: '50%',
                 transform: 'translate(-50%, -50%)',
                 width: {
                   xs: '90%',
                   sm: '70%',
                   md: '50%',
                   lg: '30%',
                 },
                 backgroundColor: 'white',
                 border: '4px solid #1E74B3',
                 borderRadius: '13px',
                 p: 2,
                 outline: 'none',
                 maxHeight: '90vh',
                 overflowY: 'auto',
               }}
             >

            <Box
  sx={{ cursor: 'pointer' }}
  onClick={() => {
    const aiScreening = localStorage.getItem('aiScreening');

    if (aiScreening !== 'true') {
      setOpenAccessPopup(true);
      return;
    }

    document.getElementById('file-upload').click();
  }}
>
  <Box
    sx={{
      border: '3px dashed #1E74B3',
      p: 2,
      borderRadius: '15px',
      my: 2,
      textAlign: 'center',
      color: '#1E74B3',
    }}
  >
    <Typography variant="body1" fontWeight="bold" mb={1}>
      Browse File
    </Typography>

    <input
      id="file-upload"
      type="file"
      accept=".doc,.docx,application/pdf"
      onChange={handleFileSelect}
      style={{ display: 'none' }}
      multiple
    />
  </Box>
</Box>
     
               {/* <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                 <Box
                   sx={{
                     border: '3px dashed #1E74B3',
                     p: 2,
                     borderRadius: '15px',
                     my: 2,
                     textAlign: 'center',
                     color: '#1E74B3',
                   }}
                 >
                   <Typography variant="body1" fontWeight="bold" mb={1}>
                     Browse File
                   </Typography>
                   <input
                     id="file-upload"
                     type="file"
                     accept=".doc,.docx,application/pdf"
                     onChange={handleFileSelect}
                     style={{ display: 'none' }}
                     multiple
                   />
                 </Box>
               </label> */}
     
               <Typography
                 variant="body1"
                 fontWeight="bold"
                 mb={1}
                 sx={{
                   textAlign: 'center',
                   color: '#1E74B3',
                 }}
               >
                 OR
               </Typography>

               <Box
                   sx={{
                      border: '3px solid #1E74B3',
                      p: 2,
                      borderRadius: '15px',
                      my: 2,
                      textAlign: 'center',
                      height: '200px',
                      color: '#1E74B3',
                      cursor: 'pointer',
                    }}
                 onClick={() => {
                    const aiScreening = localStorage.getItem('aiScreening');

                   if (aiScreening !== 'true') {
                       setOpenAccessPopup(true);
                       }
                     }}
                  onDrop={(e) => {
                       e.preventDefault();

                       const aiScreening = localStorage.getItem('aiScreening');

                       if (aiScreening !== 'true') {
                         setOpenAccessPopup(true);
                         return;
                        }

                        handleDrop(e);
                       }}
                  onDragOver={(e) => e.preventDefault()}
                  >
                  Drag & Drop to Upload File
               </Box>
     
               {/* <Box
                 sx={{
                   border: '3px solid #1E74B3',
                   p: 2,
                   borderRadius: '15px',
                   my: 2,
                   textAlign: 'center',
                   height: '200px',
                   color: '#1E74B3',
                 }}
                 onDrop={handleDrop}
                 onDragOver={(e) => e.preventDefault()}
               >
                 Drag & Drop to Upload File
               </Box> */}
     
               {fileInputFiles?.length > 0 && (
                 <Box sx={{ px: 2 }}>
                   {fileInputFiles?.map((file, index) => (
                     <Typography key={index} variant="body2">
                       {file.name}
                     </Typography>
                   ))}
                 </Box>
               )}
     
{/*              
                 <Button
                color="custom"
                variant="contained"
                 display='flex'
                 justifyContent='center'
                // sx={{ width: '15%', alignSelf: 'center' }}
              
               // onClick={} 
              >
               Screened  condidates 
              </Button> */}

              <Box
  onClick={() => {
    // yaha apna click function daal dena
     navigate(`/BulkScreen/${row._id}`, { state: { row } });
 
  }}
  sx={{
    border: '3px solid  #1E74B3',
    backgroundColor:'#1E74B3',
    p: 2,
    borderRadius: '10px',
    my: 2,
    textAlign: 'center',
    color: '#fff',
    cursor: 'pointer',
  }}
>
  <Typography variant="body1" fontWeight="bold">
    Screened Candidates
  </Typography>
</Box>
               {/* <label htmlFor="file-upload-excel" style={{ cursor: 'pointer' }}>
                 <Box
                   sx={{
                     border: '3px dashed #1E74B3',
                     p: 2,
                     borderRadius: '15px',
                     my: 2,
                     textAlign: 'center',
                     color: '#1E74B3',
                   }}
                 >
                   <Typography variant="body1" fontWeight="bold" mb={1}>
                     Browse Excel File
                   </Typography>
                   <input
                     id="file-upload-excel"
                     type="file"
                     accept=".csv,.xlsx"
                     onChange={handleFileSelectExcel}
                     style={{ display: 'none' }}
                     multiple
                   />
                 </Box>
               </label>
     
               {inputExcel?.length > 0 && (
                 <Box sx={{ px: 2 }}>
                   {inputExcel?.map((file, index) => (
                     <Typography key={index} variant="body2">
                       {file.name}
                     </Typography>
                   ))}
                 </Box>
               )}
     
               <Typography
                 color="custom"
                 variant="body2"
                 sx={{ textAlign: 'center', mt: 2 }}
               >
                 <a
                   href="/assets/Parsing-Candidate.xlsx"
                   download
                   style={{
                     textDecoration: 'underline',
                     color: '#1E74B3',
                   }}
                 >
                   Download Excel Format
                 </a>
               </Typography> */}
             </Box>
      </Modal>









          <Modal
              open={circle}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
            >
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                padding: '20px',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                {/* <h6 id="simple-modal-title">Parsing resume, Please wait...</h6> */}
                <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
                  Parsing resume, Please wait...
                </Typography>
                {/* <p id="simple-modal-description">Modal content goes here.</p> */}
                <Iconify icon="eos-icons:arrow-rotate" width="4rem" color="green" />
                {/* <CircularProgress style={{ display: open ? 'block' : 'none', marginTop: '20px' }} /> */}
              </div>
            </Modal>

            <Modal open={confirmOpen} onClose={handleConfirmNo}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '50%', md: '40%' },
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
    bgcolor: 'background.paper',
  }}>
    
    <Typography variant="h6" color="red" textAlign="center">
                Re Screen is preferred only if job is updated
               
    </Typography>

    <Stack
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      mt={2}
      alignItems="center"
      justifyContent="center"
    >
      <Button
        color="custom"
        variant="contained"
        onClick={handleConfirmYes}
      >
         Yes
      </Button>

      <Button
        color="custom"
        variant="contained"
        onClick={handleConfirmNo}
      >
        No
      </Button>
    </Stack>

  </Box>
                  </Modal>
    </>
  );
};

export default Jobs;







const Row = ({ label, item , summary }) => {
  console.log("hello")
  return (

    <Box sx={{ display: "flex", p: "12px 10px", alignItems: "center" }}>
      <Box sx={{ width: "25%", fontWeight: "bold" }}>{label}</Box>
      <Box sx={{ width: "17%", fontWeight: "bold" }}>
        {item}
      </Box>
      <Box sx={{ width: "58%" }}>{summary}</Box>
    </Box>
  );
};
















function ConsultRow({ index, row, checked1, handleCheck1, filterTab, addedSkills, hideTab }) {
  const navigate = useNavigate()
  const CircleCheckbox = styled(Checkbox)(({ theme }) => ({
    '&.Mui-checked': {
      color: '#1976d2',
      cursor: 'pointer',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      backgroundColor: '#1976d2',
      borderRadius: '50%',
    },
    '& .MuiSvgIcon-root': {
      borderRadius: '50%',
      width: 23,
      height: 23,
      border: '2px solid #1976d2',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  }));

  const styleClients1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '40%', sm: '60%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset1 = {
    position: 'absolute',
    top: '50%',
    left: '55%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '30%', sm: '50%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '50%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };

  // console.log(" rec row====>>>+++", row)
  // console.log("row.resumeUrl[0]===>>>>>>>", row.additionalResumes)

  const styleClients = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    // timeZone: 'UTC'
  };

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);

  const [addSkill, setAddSkill] = useState(false);
  const handleSkillOpen = () => setAddSkill(true);
  const handleSkillClose = () => setAddSkill(false);

  const [newSkill, setNewSkill] = useState([])
  const [details1, setDetails1] = useState([])
  // console.log("details1", details1)

  const [details2, setDetails2] = useState([])
  // console.log("details2", details2)

  const [details3, setDetails3] = useState([])
  // console.log("details3", details3)

  const [details4, setDetails4] = useState([])
  // console.log("details4", details4)

  // console.log("<<<<<<<< >>>>> newSkill", newSkill)

  const [skillss, setSkillss] = useState([])
  // console.log("skillss", skillss)

  const validSkills = row.skill.filter(item => item !== '' && item !== null);
  const validSkills1 = newSkill.filter(item => item !== '' && item !== null);

  const [hideButton, setHideButton] = useState(true)
  const [hideCross, setHideCross] = useState(true)

  const handleDeleteSkill = (index) => {
    // console.log("===============indx", index)
    // console.log("====validSkills", validSkills)

    const arrr = validSkills.filter((_, i) => i !== index);
    const arrr1 = validSkills1.filter((_, i) => i !== index);
    // console.log("arrr", arrr1)
    setNewSkill(arrr1)
  }

  const [loading12, setLoading12] = useState(false);

  const deleteSkill = async () => {
    setLoading12(true)
    // console.log('===========update', newSkill);
    const updatedSkill = [];
    newSkill?.map((item) => {
      return updatedSkill.push(item);
    });
    // console.log('=======after map skill', updatedSkill);

    const token = localStorage.getItem('token');
    const body = {
      // "newCV": "no",
      // resumeId: details4,
      bench_id: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3,
      skill: updatedSkill,
    };

    // Api(`resume/update_resume`, 'POST', body, token)
    Api(`bench/updateBenchworksheet`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          toast.success(Response.data.message);
          // fun();
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            setLoading12(false)
            // console.log('=====>', Response);
            setHideButton(true)
            setHideCross(true)
            // console.log('=====>', Response);
          } else {
            // console.log('+++======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        console.log('===========', err);
      });
  };

  const [loading11, setLoading11] = useState(false);

  const AdddSkill = async () => {
    setLoading11(true)
    // console.log('===========update', skillss);
    const updatedSkill = [];

    skillss?.forEach((item) => {
      const lowerCaseSkill = item.title.toLowerCase();
      if (!newSkill.map(skill => skill.toLowerCase()).includes(lowerCaseSkill)) {
        updatedSkill.push(item.title);
      }
    });

    const combinedSkills = [...newSkill, ...updatedSkill];
    const uniqueSkills = [...new Set(combinedSkills.map(skill => skill.toLowerCase()))];

    const token = localStorage.getItem('token');
    const body = {
      // "newCV": "no",
      bench_id: details4,
      fullName: details1,
      email: details2,
      jobTitle: details3,
      skill: uniqueSkills,
    };

    // Api(`resume/update_resume`, 'POST', body, token)
    Api(`bench/updateBenchworksheet`, 'POST', body, token)
      .then((Response) => {
        // console.log('======getUser==response=====>', Response);
        if (Response.status === 200) {
          toast.success(Response.data.message);
          // fun();
          handleCloses()
          setLoading11(false)
          handleSkillClose();
          // handleCloses()
          setSkillss([]);
          if (Response.data.code === 200) {
            toast.success(Response.data.message);
            // fun();
            handleCloses()
            setLoading11(false)
            handleSkillClose();
            // handleCloses()
            setSkillss([]);
            // console.log('=====>', Response);
          } else {
            // console.log('+++======>', +Response);
            toast.warn(Response.data.message);
            // enqueueSnackbar(Response.data.message);
          }
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
        // console.log('===========', err);
      });
  };

  const [openclient1, setOpenclient1] = useState(false);
  const [EditSumId, setEditSumId] = useState()

  const [enableEditSum, setEnableEditSum] = useState(false)
  const handleOpenclient1 = (row) => {
    setUpdateSummary(row.summary);
    setOpenclient1(true)
    if (filterTab === "worksheet") {
      setEditSumId(row._id)
    } else {
      setEditSumId(row.benchId)
    }
  }
  const handleCloseclient1 = () => setOpenclient1(false);
  const [updateSummary, setUpdateSummary] = useState('')
  const [loadingSum, setLoadingSum] = useState(false)
  const [checkRow, setCheckRow] = useState()
  const selectCheckBox = (row) => {
    setCheckRow(row)
    handleCheck1()
  }
  // console.log("checkRow", checkRow)

  const getHis = () => {
    const token = localStorage.getItem('token');
    Api(`resume/get_history/${filterTab !== 'consult' ? row._id : row.resumeId}`, 'GET', '', token)
      .then((response) => {
        // console.log('==========get_history=====>>>', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            setHis(response.data.data);
            // setJoblst(response.data.data);
          }
        }
      })
      .catch((err) => { });
  };

  const handleClosen = () => setOpenn(false);

  const [openn, setOpenn] = useState(false);
  const [his, setHis] = useState([]);
  const handleOpenn = () => {
    setOpenn(true);
    getHis();
  };

  const [openclient, setOpenclient] = useState(false);
  const handleOpenclient = () => setOpenclient(true);
  const handleCloseclient = () => setOpenclient(false);

  const [client, setClients] = useState([]);
  const getClients = async () => {
    const token = localStorage.getItem('token');
    let id;
    if (filterTab !== 'consult') {
      id = row._id
    }
    else {
      id = row.resumeId
    }
    // console.log("==========id", id)

    Api(`resume/get_history/${id}`, 'GET', '', token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========get_client_for_resume======>>>>>>>', response);
          if (response.data.code === 200) {
            setClients(response.data.data);
            // console.log('client========', JSON.stringify(response.data));
            handleOpenclient();
          } else {
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };

  return (
    <>

      <TableRow
        key={row._id}
        sx={[
          { background: index % 2 === 0 ? 'text.background' : tablebg },
          { '&:last-child td, &:last-child th': { border: 0 } },

          { '&:hover': { boxShadow: 5 } },
        ]}
      >
        <TableCell sx={{}}>

          {/* <Stack sx={{ml:2}}> */}

          <Typography sx={{ color: 'text.secondary', ml: 4.1 }} >
            Up - {`${new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt)?.toLocaleString('en-US', optionsDate)} 
 ${String(new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt).getHours())?.padStart(2, '0')}`}:{`${String(new Date(row?.benchAppId?.updatedAt || row?.recruitorAppId?.updatedAt || row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
          </Typography>

          <FormControlLabel sx={{ ml: -1.3, mt: -2, mb: -2 }}
            control={
              checked1 ? (
                <Checkbox
                  // icon="ri:checkbox-circle-line"
                  // color='#1976d2'
                  // width="17px"
                  // height="17px"
                  onClick={() => selectCheckBox(row)}
                />
              ) : (
                <Checkbox
                  // icon="ri:checkbox-blank-circle-line"
                  // width="17px"
                  // height="17px"
                  // color='#1976d2'
                  onClick={() => selectCheckBox(row)}
                />
              )
            }
          />

          <Typography sx={{ ml: 4.1 }} >
            Cr - {`${new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.toLocaleString('en-US', optionsDate)} 
 ${String(new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(row?.benchAppId?.createdAt || row?.recruitorAppId?.createdAt || row?.updatedAt)?.getMinutes())?.padStart(2, '0')}`}
          </Typography>
          {/* </Stack> */}

          {/* <Typography sx={{ml:2.5}} >-</Typography> */}
        </TableCell>
        <TableCell sx={{}}>
          <Typography
            sx={{
              color: 'text.secondary', fontWeight: '600', fontSize: '0.9rem',
              maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis',
              cursor: "pointer"
            }}
            onClick={() => {
              const fTab =
                filterTab === 'worksheet' ? 'submitted' :
                  '';
              if (filterTab === 'consult') {
                navigate('/benchresumedetails', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab,
                  },
                });
              } else {
                navigate('/resumeDetail', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab,
                  },
                });
              }
            }}
          >
            {row?.benchAppId?.fullName || row?.recruitorAppId?.fullName || row?.fullName || '-'}
          </Typography>
          <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row?.benchAppId?.currentCompany ||
              row?.recruitorAppId?.currentCompany || row?.currentCompany || "-"}
          </Typography>
          <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
            {row?.benchAppId?.jobTitle ||
              row?.recruitorAppId?.jobTitle || row?.jobTitle || "-"
            }
          </Typography>
        </TableCell>
        <TableCell sx={{}}>
          {filterTab === "consult" ? (
            <>
              <Typography
                sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.benchAppId?.phone ||
                  row?.recruitorAppId?.phone || row?.phone || "-"
                }
              </Typography>
              <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                {row?.benchAppId?.email ||
                  row?.recruitorAppId?.email || row?.email || "-"
                }
              </Typography>
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography >
                  {
                    (row?.benchAppId?.city || row?.benchAppId?.stateCode)
                      ? `${row?.benchAppId?.city}, ${row?.benchAppId?.stateCode}`
                      : (row?.recruitorAppId?.city || row?.recruitorAppId?.stateCode
                        ? `${row?.recruitorAppId?.city}, ${row?.recruitorAppId?.stateCode || '-'}`
                        : (row?.city || row?.stateCode
                          ? `${row?.city}, ${row?.stateCode || '-'}`
                          : '-')
                      )
                  }


                </Typography>
                {row?.relocation === 'yes' ? (
                  <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                ) : ''}
              </Stack>
            </>
          ) : (
            <>
              <Typography
                sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {row?.benchAppId?.phone ||
                  row?.recruitorAppId?.phone || row?.phone || "-"
                }
              </Typography>
              <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                {row?.benchAppId?.email ||
                  row?.recruitorAppId?.email || row?.email || "-"
                }
              </Typography>
              <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <Typography >
                  {
                    (row?.benchAppId?.city || row?.benchAppId?.stateCode)
                      ? `${row?.benchAppId?.city}, ${row?.benchAppId?.stateCode}`
                      : (row?.recruitorAppId?.city || row?.recruitorAppId?.stateCode
                        ? `${row?.recruitorAppId?.city}, ${row?.recruitorAppId?.stateCode || '-'}`
                        : (row?.city || row?.stateCode
                          ? `${row?.city}, ${row?.stateCode || '-'}`
                          : '-')
                      )
                  }
                </Typography>
                {row?.relocation === 'yes' ? (

                  <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
                ) : ''}
              </Stack>
            </>
          )}

        </TableCell>
        <TableCell sx={{ width: 190 }}>
          {row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill && row?.benchAppId?.skill.length > 0 || row?.recruitorAppId?.skill.length > 0
            || row?.skill && row?.skill.length > 0 ? (
            <Grid container sx={{ maxWidth: 160, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
              {row?.benchAppId?.skill || row?.skill || row?.recruitorAppId?.skill?.map((item, index) => (
                item && (
                  <Typography key={index} sx={{}}>
                    {item}
                    {index < row?.benchAppId?.skill || row?.skill || row?.recruitorAppId?.skill?.filter(skill => skill).length - 1 && ' | '}
                  </Typography>
                )
              ))}
            </Grid>
          ) : (
            <Typography>-</Typography>
          )}
          {row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill && row?.benchAppId?.skill?.length > 0 || row?.recruitorAppId?.skill?.length > 0 || row?.skill?.length > 0 ? (
            <Typography
              sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                handleOpens(); setNewSkill(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill); setDetails1(row?.benchAppId?.fullName || row?.recruitorAppId?.fullName);
                setDetails2(row?.benchAppId?.email || row?.recruitorAppId?.email); setDetails3(row?.benchAppId?.jobTitle || row?.recruitorAppId?.jobTitle);
                setDetails4(row?.benchAppId?._id || row?.recruitorAppId?._id)
              }}
            >
              view all
            </Typography>
          ) : null}
        </TableCell>
        <TableCell sx={{ width: 110, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: -0.6, color: 'text.secondary' }}>
              <Typography sx={{ paddingRight: 1 }}>
                {row?.benchAppId?.visaType || row?.recruitorAppId?.visaType || row?.visaType ? row?.benchAppId?.visaType || row?.recruitorAppId?.visaType || row?.visaType : '-'}
              </Typography>
              {row?.benchAppId?.visaTransfer || row?.recruitorAppId?.visaTransfer || row?.visaTransfer === "yes" ? (
                <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
              ) : null}
            </Box>
            <Typography sx={{}}>
              {row?.benchAppId?.offeredJob || row?.recruitorAppId?.offeredJob || row?.offeredJob &&
                (row?.benchAppId?.annualSalary || row?.recruitorAppId?.annualSalary || row?.annualSalary
                  || row?.benchAppId?.hourlyRateRateOffered || row?.recruitorAppId?.hourlyRateRateOffered || row?.hourlyRateRateOffered)
                && (
                  <>
                     {row?.benchAppId?.country === "INDIA"  ? "₹"  : row?.benchAppId?.country === "UK" ? "£"  : "$"}

                    {row?.benchAppId?.offeredJob || row?.recruitorAppId?.offeredJob || row?.offeredJob === 'fulltime' ? row?.benchAppId?.annualSalary || row?.recruitorAppId?.annualSalary || row?.annualSalary
                      : row?.benchAppId?.hourlyRateRateOffered || row?.recruitorAppId?.hourlyRateRateOffered || row?.hourlyRateRateOffered}
                    {row?.benchAppId?.chargeType || row?.recruitorAppId?.chargeType || row?.chargeType === 'hourly' ? '/Hour' : 'K'}
                  </>
                )}
            </Typography>
            <Typography sx={{}}>
              {row?.benchAppId?.expectedCompensation || row?.recruitorAppId?.expectedCompensation || row?.expectedCompensation && (
                <>
                  {row?.benchAppId?.country === "INDIA"  ? "₹"  : row?.benchAppId?.country === "UK" ? "£"  : "$"}

                  {row?.benchAppId?.expectedCompensation || row?.recruitorAppId?.expectedCompensation || row?.expectedCompensation}
                  {row?.benchAppId?.chargeType || row?.recruitorAppId?.chargeType || row?.chargeType === 'hourly' ? '/Hour' : 'K'}
                </>
              )}
            </Typography>
            <Typography sx={{ textTransform: "capitalize" }} color={'text.textG'}>
              {row?.benchAppId?.taxTerm || row?.recruitorAppId?.taxTerm || row?.taxTerm ? row?.benchAppId?.taxTerm || row?.recruitorAppId?.taxTerm || row?.taxTerm : '-'}
            </Typography>
          </>
        </TableCell>

        {filterTab === "consult" &&

          <>
            <TableCell sx={{ mt: -0.3 }}>

              <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => handleOpenclient1(row)}>

                Summary
              </Typography>
              <Typography>{"Exp - "}{row.experienceInYear || row?.benchAppId?.experienceInYear || row?.benchAppId?.experienceInYear}{" Yrs"}</Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                {row.DOB || row?.benchAppId?.DOB || row?.benchAppId?.DOB ? (
                  <>
                    D.O.B - {moment(row.DOB || row?.benchAppId?.DOB || row?.benchAppId?.DOB).format('ll')}
                  </>
                ) : (
                  '-'
                )}
              </Typography>
            </TableCell>
          </>

        }

        {/* {filterTab !== "consult" ?
          (
            (!row.otherData ? (
              <>
                <TableCell sx={{ py: 0, width: 130, overflow: 'hidden', textOverflow: 'ellipsis' }}>

                  <Typography sx={{}}>
    {row?.benchAppId?.startStatus || row?.recruitorAppId?.startStatus !== '' ? 
    row?.benchAppId?.startStatus || row?.recruitorAppId?.startStatus : row?.benchAppId?.status || row?.recruitorAppId?.status}
  </Typography>

                  <Stack sx={{ flexDirection: 'row', gap: 0.5 }}>

                    <Stack sx={{ flexDirection: 'row' }}
                      onClick={(e) => getClients()}
                    >
                      <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
                      <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>
                        {row?.benchAppId?.clients || row?.recruitorAppId?.clients ? `+${row?.benchAppId?.clients || row?.recruitorAppId?.clients}` : ''}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Typography sx={{}} color={'text.textG'}>
                    {row?.benchAppId?.contactPersonName || row?.recruitorAppId?.contactPersonName ?row?.benchAppId?.contactPersonName || row?.recruitorAppId?.contactPersonName : '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography>-</Typography>

                  <Typography
                    sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => handleOpenn()}
                  >
                    Notes
                  </Typography>
                  <Typography>-</Typography>
                </TableCell>

                <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                  <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                    <Iconify icon="ic:baseline-email" fontSize={10} />
                    <Typography sx={{}}
                    >Email</Typography>
                  </Stack>
                  <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                    <Iconify icon="bx:support" fontSize={10} />
                    <Typography sx={{}}>Contact</Typography>
                  </Stack>
                  {row?.benchAppId?.userStatus || row?.recruitorAppId?.userStatus !== 'fake' && row?.benchAppId?.userStatus || row?.recruitorAppId?.userStatus !== 'blacklisted' ? (
                    <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
                      {row?.benchAppId?.userStatus || row?.recruitorAppId?.userStatus !== 'quit' && row?.benchAppId?.userStatus || row?.recruitorAppId?.userStatus !== 'terminated' && row?.benchAppId?.userStatus || row?.recruitorAppId?.userStatus !== 'project ended' ? (
                        <Iconify icon="icon-park-solid:check-one" fontSize={10} />
                      ) : (
                        <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
                      )}

                      <Typography
                      
                      >
                        {row?.benchAppId?.status || row?.recruitorAppId?.status === 'prospect' ? 'Submit' : 'Resubmit'}
                      </Typography>


                    </Stack>
                  ) : (
                    <Typography sx={{ color: 'transparent' }}>cdcd</Typography>
                  )}
                </TableCell>
              </>
            ) : (
              <>

                <TableCell sx={{}}>
                  <Typography variant="body1" sx={{ ml: 2 }}>
                    -
                  </Typography>

                </TableCell>

                <TableCell sx={{}}>
                  <Stack sx={{ mt: 1.4 }}>
                    <img
                      alt="Company Logo"
                      src="/assets/logoBlue.svg"
                      style={{ width: '100%', height: '90%' }}
                    />

                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack sx={{ mt: 2 }}>

                    <Typography variant="body1" sx={{ ml: 2 }}>
                      -
                    </Typography>
                  </Stack>
                </TableCell>
              </>
            ))
          ) : (
            <>
              <TableCell sx={{ mt: -0.3 }}>

                <Typography sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => handleOpenclient1(row)}>
                 
                  Summary
                </Typography>
                <Typography>{"Exp - "}{row.experienceInYear}{" Yrs"}</Typography>
                <Typography sx={{ color: 'text.secondary' }}>
                  {row.DOB ? (
                    <>
                      D.O.B - {moment(row.DOB).format('ll')}
                    </>
                  ) : (
                    '-'
                  )}
                </Typography>
              </TableCell>
            </>
          )
        } */}

        <Modal open={openclient} onClose={handleCloseclient} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
              Activities
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ alignItems: 'center' }}>
                <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
                  <Stack
                    sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Date
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      User Name
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job ID
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Client
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Job Title
                    </Typography>
                    <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                      Status
                    </Typography>
                  </Stack>
                </Stack>

                {client
                  ? client.map((item, index) => {
                    // console.log('client list----------------------', item);
                    return (
                      <Stack
                        sx={[
                          { background: index % 2 === 0 ? 'text.background' : tablebg },
                          { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                        ]}
                      >
                        <Typography sx={{ width: '25%' }}>
                          {/* {moment(`${item.createdAt}`).format('lll')} */}
                          {`${new Date(item?.createdAt)?.toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>
                          {item.actionBy}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobId ? item.jobId : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.clientName ? item.clientName : '-'}
                        </Typography>
                        <Typography sx={{ width: '20%', textTransform: 'capitalize' }}>
                          {item.jobIdTitle || item.jobTitle}
                        </Typography>
                        <Typography
                          sx={[
                            {
                              color:
                                item.actionTo === 'started' || item.actionTo === 'placement'
                                  ? 'green'
                                  : item.actionTo === 'Backout from Job offer'
                                    ? 'red'
                                    : '',
                            },
                            { width: '20%', textTransform: 'capitalize' },
                          ]}
                        >
                          {item.actionTo}
                        </Typography>
                      </Stack>
                    );
                  })
                  : null}
              </Stack>
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
          <Box sx={styleClients}>
            {/* <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Button
              // sx={{width:'13%'}}
              color="custom"
              variant="contained"
              size="small"
              onClick={() =>
                navigate('/resumeDetail', {
                  state: {
                    addedSkills,
                    row,
                    mtab: 'Resume',
                    fTab:
                      filterTab === 'worksheet'
                        ? 'submitted'
                        : '' || filterTab === 'favourites'
                          ? 'submitted'
                          : '' || filterTab === 'interview'
                            ? 'placement'
                            : '' || filterTab === 'placement'
                              ? 'start'
                              : '',
                  },
                })
              }
            >
              Add Note
             
            </Button>
          </Stack> */}
            <Typography variant="h5" color={'#3C6BA5'} sx={{ textTransform: 'capitalize', mt: -3 }} textAlign={'center'}>
              {/* {row.fullName.split(" ",1)}'s Notes */}
              {/* {row.fullName}'s Notes */}
              {/* {/\s/.test(row.fullName) ? row.fullName.split(" ", 1) : row.fullName}'s  */}
              Notes
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
              <Stack sx={{ backgroundColor: 'text.secondary', flexDirection: 'row', p: 1, py: 0.5, borderRadius: 1 }}>
                <Typography color={'white'} sx={{ width: '16%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Date
                </Typography>
                <Typography color={'white'} sx={{ width: '10%', fontSize: '0.976rem', fontWeight: '600' }}>
                  User
                </Typography>
                <Typography color={'white'} sx={{ width: '80%', fontSize: '0.976rem', fontWeight: '600' }}>
                  Note
                </Typography>
              </Stack>
              {his.length
                ? his.map((item, index) => {
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { flexDirection: 'row', p: 1 },
                      ]}
                    >
                      <Typography sx={{ width: '16%' }}>
                        {/* {moment(`${item.createdAt}`).format('lll')} */}
                        {`${new Date(item.createdAt)?.toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                      </Typography>
                      <Typography sx={{ width: '10%', textTransform: 'capitalize', fontWeight: '800', color: 'text.secondary' }}>{item.actionBy}</Typography>
                      <Typography sx={{ width: '80%' }}>
                        {item.note}
                        {/* <div dangerouslySetInnerHTML={{ __html: item.note }} /> */}
                      </Typography>
                    </Stack>
                  );
                })
                : null}
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={openclient1} onClose={handleCloseclient1} style={{ borderRadius: 10 }}>
          <Box sx={styleClients1}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: '100%' }}
            >
              <Typography
                variant="h5"
                color={'#3C6BA5'}
                textAlign={'center'}
                sx={{ flexGrow: 1, textAlign: 'center' }}
              >
                {/* {row.fullName}'s  */}
                Summary
              </Typography>
              {/* {!enableEditSum && (

  <Button color="custom" variant="contained" onClick={(e)=>setEnableEditSum(true)}>
    Edit
  </Button>
  )}  */}
              {enableEditSum && (
                <Button color="custom" variant="contained" size="small" disabled={loadingSum}
                // onClick={(e)=>editSummary()}
                >
                  {loadingSum ? <CircularProgress size={22} /> : 'Save'}

                </Button>
              )
              }
            </Stack>

            <Divider sx={{ mt: 1, mb: 1, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            {!enableEditSum && (

              <Typography sx={{ width: '100%', fontSize: '0.976rem', fontWeight: '100' }}>
                {row.summary}
              </Typography>
            )}
            {enableEditSum && (

              <TextField
                sx={{}}
                id="outlined-multiline-static"
                label="Summary"
                multiline
                rows={4}
                width="100%"
                fullWidth
                value={updateSummary}
                onChange={(e) => setUpdateSummary(e.target.value)}

              />
            )}
          </Box>
        </Modal>


        <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
          <Box sx={styleSkillset11}>
            <Stack sx={{ float: "right" }} direction="row" spacing={1.9}>
              {/* <Button color="custom" variant="contained"  onClick={handleSkillOpen}>Add</Button> */}
              {/* {hideButton && (

    <Button color="custom" variant="contained"  onClick={() => { setHideButton(!hideButton); setHideCross(false) }}>Delete
    </Button>
  )}  */}
              {!hideButton && (

                <Button color="custom" variant="contained" onClick={() => { deleteSkill() }}
                  disabled={loading12}
                >
                  {/* Save */}
                  {loading12 ? <CircularProgress size={24} /> : 'Save'}
                </Button>
              )}
            </Stack>
            <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: "46%" }}>
              Skills

            </Typography>

            <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
              <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
              <Stack
                sx={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: 0.5,


                  flexWrap: 'wrap'
                }}
              >
                {/* {row.skill?.map((item, index) => (
        item && (
          <Typography
            key={index}
            variant="h6"
            color="text.textG"
            textAlign="center"
            sx={{ mt: 2 }}
          >
            {item}
            {index < row.skill.filter(skill => skill).length - 1 && ' | '}
          </Typography>
        )
      ))} */}

                {/* {row.skill?.map((item, index) => ( */}
                {newSkill?.filter(item => item !== '' && item != null).map((item, index) => (

                  item && (
                    <Box
                      key={index}
                      sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant="h6"
                        color="text.textG"
                        textAlign="center"
                        textTransform="capitalize"
                        sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                      >
                        {item} {index < row.skill.length - 1 && '|'}

                        {!hideCross && (
                          <Iconify
                            icon="system-uicons:cross-circle"
                            width="1.45rem"
                            height="1.45rem"
                            sx={{
                              position: 'absolute',
                              top: '-15px',
                              right: '1px',
                              cursor: 'pointer',
                              color: 'red',
                            }}
                            onClick={() => handleDeleteSkill(index)}
                          />
                        )}

                      </Typography>
                    </Box>
                  )
                ))}

              </Stack>
            </Scrollbar>
          </Box>
        </Modal>

        <Modal open={addSkill} onClose={handleSkillClose} sx={{ borderRadius: 10 }}>
          <Box sx={styleSkillset1}>
            <Stack spacing={3}>
              <Autocomplete
                multiple
                id="tags-outlined"
                onChange={(event, newValue) => {
                  setSkillss([...newValue]);
                }}
                options={addedSkills}
                getOptionLabel={(option) => option.title}
                value={skillss}
                filterSelectedOptions
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);
                  const { inputValue } = params;

                  const isExisting = options.some((option) => inputValue === option.title);
                  if (inputValue !== '' && !isExisting) {
                    filtered.push({
                      inputValue,
                      title: `${inputValue}`,
                    });
                  }
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Skills" placeholder="Enter Skill" autoFocus />
                )}
              />
              <Stack direction="row" justifyContent="center" spacing={3}>
                <Button
                  color="custom"
                  variant="contained"
                  onClick={() => {
                    // handleSkillClose();
                    // handleCloses()
                    // setSkillss([]);
                    AdddSkill()
                  }}
                  disabled={loading11}
                >
                  {/* Add Skill */}
                  {loading11 ? <CircularProgress size={24} /> : 'Add Skill'}
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Modal>
      </TableRow>
    </>
  );
};

const StyledIconButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
});





function Search({ searchData, func, funcc, funnc, resetSearch, onData, onData1, onData2 }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formValues, setFormValues] = useState({
    commonSearch: "",
  });

  const [Values, setValues] = useState({
    commonSearch: "",
    addedBy: "",
    status: "",
    fromDate: "",
    tillDate: "",
    jobType: "",
    jobTime: "",
    priority: ''
  });

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState('');
  const CommonSearcFun = (page = 1) => {
    searchData('')
    // searchData([])
    setLoading(true);
    setLoadingData('Loading...')
    const body = {
      "commonSearch": Values.commonSearch,
      // "resource": Values.addedBy,
      "addedById": Values.addedBy,
      "status": Values.status,
      "priority": Values.priority,
      "fromDate": Values.fromDate,
      "tillDate": Values.tillDate,
      "remote": Values.jobType,
      // "jobType": Values.jobType
      "jobType": Values.jobTime,
      "page": page,
      "limit": "50"
    }

    const token = localStorage.getItem('token');
    Api('common/search/jobs', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            if (response.data.data && response.data.data.length > 0) {
              // searchData(response.data.data);
              const totalPage = Math.ceil(response.data?.count / 35) 
              searchData(response.data.data, response.data.count, totalPage)
              setLoadingData('');
              setLoading(false);
              handleSearchClose();
            } else {
              searchData([]);
            }
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [loading1, setLoading1] = useState(false);

  const fn = (page = 1) => {
    searchData('')
    setLoading1(true)
    const body = {
      "commonSearch": formValues.commonSearch,
      "page": page,
      "limit": "50"
    }
    const token = localStorage.getItem('token');
    Api('common/search/jobs', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            const totalPage = Math.ceil(response.data.count / 35)
            searchData(response.data.data, response.data.count, totalPage)

            setLoading1(false)
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    resetSearch()
    clearInputField()
    setIsVisible(!isVisible);
    func()
    setFormValues({ ...formValues, commonSearch: '' });
  };

  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  // const handleDateChange = (date, field) => {
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     [field]: date ? date.toISOString() : null,
  //   }));
  // };

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setValues((prevRec) => ({
      ...prevRec,
      [field]: formattedDate
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  const clearInputField = () => {
    setValues({
      ...Values,
      commonSearch: '',
      addedBy: "",
      status: "",
      fromDate: "",
      tillDate: "",
      jobType: "",
      jobTime: '',
      priority: ""
    });

  }

  const [userdata, setUserdata] = useState([])
  // console.log("userdata ===>>>>", userdata)
  // useEffect(() => {
  //   allUsers()
  // }, []);

  const allUsers = () => {

    const token = localStorage.getItem('token');
    // Api('company/all_users', 'GET', '', token)
    Api('company/jobAddedByList', 'GET', '', token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.status === 200) {
          setUserdata(response?.data?.result);
            // const users = response.data.data;
            // console.log("response.data.data", response.data.result)
            // const contactPersonNames = users.map(user => user.contactPersonName);

          } else {
            // console.log('Error:', response.data.message);
          }

        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const sendDataToParent = () => {
    onData(clearInputField);
  };

  // const funn = (page) =>{
  //   fn(page)
  // }
  const sendDataToParent1 = () => {
    onData1(CommonSearcFun, loadingData);
  };

  const [pageNumber, setPageNumber] = useState(1)
  // const [loading, setLoading] = useState(false);
  // const [loading1, setLoading1] = useState(false);

  const sendDataToParent2 = () => {
    onData2(pageNumber);
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClose}>
        <div>

          {/* {!open && (
          <IconButton onClick={handleOpen}>
            <Iconify icon="eva:search-fill" sx={{ color: 'text.primary', width: 30, height: 30 }} />
          </IconButton>
        )} */}


          <div className='mob_search'>
            <Paper
              component="form"
              sx={{
                // p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                border: '1px solid #1E74B3',
                borderRadius: '10px',
                marginTop: -18,
              }}
            >
              {/* <IconButton sx={{ p: '0.1px', ml: "7px" }}>
              <Iconify icon="eva:search-outline" />
            </IconButton> */}
              <InputBase
                sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
                placeholder="Job Id | Job Title"
                inputProps={{ 'aria-label': 'search' }}
                value={formValues.commonSearch}
                onChange={(e) => setFormValues({ ...formValues, commonSearch: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    fn();
                    funcc();
                    sendDataToParent1()
                  }
                }}
              />
            </Paper>
            {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} onClick={fn}>Search</Button> */}
            <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
              onClick={() => { fn(); funcc() }}
              disabled={loading1}

            >
              {/* Search */}
              {loading1 ? <CircularProgress size={24} /> : 'Search'}
            </Button>
            {(formValues.commonSearch ||
              Values?.commonSearch ||
              Values?.addedBy ||
              Values?.status ||
              Values?.fromDate ||
              Values?.tillDate ||
              Values?.jobType ||
              Values?.jobTime ||
              Values.priority
            )
              && (
                // <IconButton
                //   sx={{ p: '1px', ml: '6px' }}
                //   color="custom"
                //   variant="contained"
                //   size="large"
                //   onClick={toggleVisibility}
                // >
                //   <Iconify icon="oui:cross-in-circle-filled" width="1.7rem" />
                // </IconButton>
                <Button color="custom" variant="contained" size="small"
                  sx={{ ml: 1.6, mt: -18 }}
                  onClick={() => { toggleVisibility(); funnc(); sendDataToParent2() }}>
                  Close
                </Button>
              )}

          </div>



          <StyledIconButtonWrapper onClick={handleSearchOpen}>
            <IconButton className='morFiltr'>
              <Iconify
                icon="bxs:down-arrow"
                color="#1E74B3"
              />
            </IconButton>
          </StyledIconButtonWrapper>
        </div>
      </ClickAwayListener>

















        <Modal open={searchOpen} onClose={handleSearchClose}>

        <Box className="morFltr_pop" sx={{
          position: 'absolute',
          top: '34%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 2,
          borderRadius: 3,
        }}
        >

          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12} >
              <TextField
                label="Job ID / Job Title"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"

                value={Values.commonSearch}
                onChange={(e) => setValues({ ...Values, commonSearch: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    CommonSearcFun();
                    handleSearchClose();
                    funcc()
                  }
                }}
              />
            </Grid>

            <Grid container sx={{ flexDirection: "row", marginLeft: '1px' }} spacing={1}>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From"
                      slotProps={{ textField: { size: "small" } }}
                      value={Values.fromDate ? dayjs(Values.fromDate) : null}
                      // onChange={(date) => handleDateChange1(date, 'fromDate')}
                      onChange={(date) => handleDateChange(date, 'fromDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Till"
                      slotProps={{ textField: { size: "small" } }}
                      value={Values.tillDate ? dayjs(Values.tillDate) : null}
                      // onChange={(date) => handleDateChange1(date, 'tillDate')}
                      onChange={(date) => handleDateChange(date, 'tillDate')}
                    /> 
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={Values.status}
                  label="Status"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setValues({ ...Values, status: e.target.value })}
                >
                  {/* {Domains.map((item) => {
           return <MenuItem value={item}>{item}</MenuItem>
         })} */}

                  <MenuItem value={"Active"}>Active</MenuItem>
                  <MenuItem value={"On Hold"}>On Hold</MenuItem>
                  <MenuItem value={"Closed"}>Closed</MenuItem>
                  <MenuItem value={"cancelled"}>Cancelled</MenuItem>

                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel >Added By</InputLabel>
                <Select
                  // labelId="resource-label"
                  label="Added By"
                  value={Values.addedBy}
                  onChange={(e) => setValues({ ...Values, addedBy: e.target.value })}
onOpen={allUsers}
                >
                  {/* {userdata.map((item, index) => (
            <MenuItem key={index} value={item._id}>
              {item.contactPersonName}
            </MenuItem>
          ))} */}
                  {userdata?.map((item, index) => (
                    <MenuItem key={index} value={item?.addedById}
                    style={{ color: item?.status === 'inactive' ? 'red' : '' }}
                    >
                      {item?.addedByName}
                    </MenuItem>
                  ))}
                  {/* <MenuItem value={"Tony"}>Tony</MenuItem>
          <MenuItem value={"Tom"}>Tom</MenuItem>
          <MenuItem value={"Stark"}>Stark</MenuItem>
          <MenuItem value={"Homelander"}>Homelander</MenuItem> */}
                  {/* <MenuItem value={"Inactive"}>Kyra</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>

              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Remote</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={value.domain}
                  value={Values.jobType}
                  label="Job Type"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setValues({ ...Values, jobType: e.target.value })}
                >
                  {/* {Domains.map((item) => {
           return <MenuItem value={item}>{item}</MenuItem>
         })} */}

                  <MenuItem value={"onsite Job"}>Onsite</MenuItem>
                  <MenuItem value={"remote"}>Remote</MenuItem>
                  <MenuItem value={"hybrid"}>Hybrid</MenuItem>

                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Job Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Job Type"
                  placeholder="Job Type"
                  value={Values.jobTime}
                  onChange={(e) => setValues({ ...Values, jobTime: e.target.value })}
                >
                  <MenuItem value={'fulltime'}>Full Time</MenuItem>
                  <MenuItem value={'permanent'}>Permanent</MenuItem>
                  <MenuItem value={'contract'}>Contract</MenuItem>
                  <MenuItem value={'CTH'}>CTH</MenuItem>
                  <MenuItem value={'temporary'}>Temporary</MenuItem>
                  <MenuItem value={'internship'}>Internship</MenuItem>
                  <MenuItem value={'parttime'}>Part Time</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Priority"
                  placeholder="Priority"
                  value={Values.priority}
                  onChange={(e) => setValues({ ...Values, priority: e.target.value })}
                >
                  <MenuItem value={'Top Priority'}>Top Priority</MenuItem>
                  <MenuItem value={'Mid Priority'}>Mid Priority</MenuItem>;
                  <MenuItem value={'Low Priority'}>Low Priority</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} textAlign="center" sx={{ marginTop: "5px" }}>
              <Button color="custom" variant="contained" size="small"
                // onClick={() => { handleSearch(); funcc() }}
                onClick={() => { CommonSearcFun();
                                //  CommonSearcFun();
                                //  funcc();
                                //  sendDataToParent1();
                                 }}
              // onKeyDown={(e) => {
              //   if (e.key === 'Enter') {
              //     e.preventDefault(); 
              //     CommonSearcFun();
              //     handleSearchClose(); 
              //     funcc()
              //   }

              // }}
              disabled={loading}
              >
                 {loading ? (
    <CircularProgress size={20} color="inherit" />
  ) : (
    'Search'
  )}
                {/* Search */}
              </Button>
              <Button color="custom" variant="contained" size="small"
                sx={{ marginLeft: '12px' }}
                onClick={clearInputField}
              >
                Clear All
              </Button>
            </Grid>
          </Grid>




        </Box>
      </Modal>  


    </>
  );
}


//  <Button color="custom" variant="contained" size="small" onClick={() => navigate('/addjob', { state: { row: '' } })}
//           // sx={{ml:1}}
//           >

//             Add New Job
//           </Button>